import React, {Component} from "react";
import TagManager from "react-gtm-module";
import Cookies from "js-cookie";
import querystring from "query-string";
import axios from "axios";
import {useHistory, withRouter} from "react-router-dom";
import Select, {components} from "react-select";
import Header from "../components/Header/Header";
import ContinueShopping from "../components/ContinueShopping/ContinueShopping";
import CheckoutSummary from "../components/CheckoutSummary/CheckoutSummary";
import Address from "../components/Address/Address";
import ConfirmBag from "../components/ConfirmBag/ConfirmBag";
import ConfirmEmail from "../components/ConfirmEmail/ConfirmEmail";
import ConfirmDelivery from "../components/ConfirmDelivery/ConfirmDelivery";
import Accordion from "../components/Accordion/Accordion";
import Modal from "../components/Modal/Modal";
import Loader from "../components/Loader/Loader";
import MobileNav from "../components/MobileNav/MobileNav";
import AddressForm from "../components/AddressForm/AddressForm";
import ApiError from "../components/ApiError/ApiError";
import Banner from "../components/Banner/Banner";
import CheckoutPageError from "../components/CheckoutPageError/CheckoutPageError";
import BillingOptions from "../components/BillingOptions/BillingOptions";
import * as GlobalStyle from "../CSSStyles";

const gtmId = "GTM-MXMG453";

class Checkout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customerId: Cookies.get("KK_CUSTOMER_ID"),
      customerEmail: Cookies.get("kkUserEmail"),
      OrderSummary: [],
      confirmAddressSummary: [],
      confirmAvailable: [],
      confirmUnavailable: [],
      confirmPreorder: [],
      confirmPreorderPartial: [],
      confirmMarketRestricted: [],
      confirmPartial: [],
      confirmItemCount: 0,
      totalItemCount: 0,
      confirmShippingSummary: [],
      allBag: [],
      countries: [],
      zones: [],
      stateZone: [],
      userAddresses: [],
      postCodeValidation: [],
      //test api
      // getAllCountriesAPIURL: "../test_data/all_countries_api.json",
      // getNonDisplayCountriesAPIURL: "../test_data/non_display_countries_api.json",
      // getAllCountriesAPIURL_json: "../data/all_countries.json",
      // getAUCountriesAPIURL_json: "../data/au_countries.json",
      // getNonDisplayCountriesAPIURL_json: "../data/non_display_countries.json",
      // getCountryProvinceLabelAPIURL: "../data/countryProvinceLabel.json",
      // getPostCodeValidationAPIURL: "../data/postcodeValidation.json",
      // getOrderDetailsAPIURL: "../test_data/order-details.json",
      // getZonesAPIURL: "../test_data/getlistzones.json",
      //actual api
      getAllCountriesAPIURL: "/api/checkout/get-countries",
      getNonDisplayCountriesAPIURL: "/api/checkout/get-countries?state=1",
      getAllCountriesAPIURL_json: "./data/all_countries.json",
      getAUCountriesAPIURL_json: "./data/au_countries.json",
      getNonDisplayCountriesAPIURL_json: "./data/non_display_countries.json",
      getCountryProvinceLabelAPIURL: "./data/countryProvinceLabel.json",
      getPostCodeValidationAPIURL: "./data/postcodeValidation.json",
      getOrderDetailsAPIURL: "/api/checkout/order-details",
      getZonesAPIURL: "/api/checkout/getlistzones",
      //
      addAddressAPIURL: "/api/checkout/add-address-details",
      editAddressAPIURL: "/api/checkout/edit-address-details",
      deleteAddressAPIURL: "/api/checkout/delete-address-details",
      changeDeliveryAddressAPIURL: "/api/checkout/shipping-address-status",
      changeBillingAddressAPIURL: "/api/checkout/billing-address-status",
      removeBagAPIURL: "/api/checkout/remove-bag-item",
      updateBagAPIURL: "/api/checkout/update-bag-item",
      updateMiniCartAPIURL: "/api/checkout/clear-mini-cart",
      registerGuestAPIURL: "/api/checkout/register-guest",
      confirmPaymentAPIURL: "/api/checkout/confirm-payment",
      // getOptionalPhoneCountriesAPIURL: "./data/optionalPhoneCountries.json",
      // getOptionalPhoneCountriesAPIURL: "../data/optionalPhoneCountries.json",
      addAddressAPIErrors: "",
      confirmAPIErrors: "",
      confirmAPIErrorMessage: "",
      confirmAPIErrorCode: "",
      isAddAddress: false,
      isConfirmApiLoaded: false,
      isBagOpen: false,
      isDeliveryOpen: false,
      isBillingOpen: false,
      confirmCurrency: "",
      confirmCurrencyCode: "",
      promoInput: "",
      promoCodeMessage: false,
      isContinuePaymentValid: false,
      defaultDeliveryAddressID: "",
      defaultBillingAddressID: "",
      addAddressType: "",
      guestEmailHasValue: "",
      addressRegionHasValue: "",
      addressStateZoneHasValue: "",
      addressFirstNameHasValue: "",
      addressLastNameHasValue: "",
      addressLine1HasValue: "",
      addressLine2HasValue: "",
      addressCityHasValue: "",
      addressStateZoneHasValue: "",
      addressStateHasValue: "",
      addressPostalHasValue: "",
      addressPhoneHasValue: "",
      addAddressLineShow: false,
      countryFocus: "",
      stateZoneFocus: "",
      isSameAsDelivery: false,
      initialAddress: "",
      initialBilling: "",
      orderDetailsError: false,
      guestEmail: "",
      addAddressField: {
        id: "",
        countryCode: "",
        countryName: "",
        stateZoneCode: "",
        stateZoneName: "",
        stateName: "",
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        postCode: "",
        phoneNumber: "",
        emailAddr: "",
      },
      submitAddAddress: {
        id: "",
        customerId: "",
        countryId: "",
        countryCode: "",
        countryName: "",
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        stateZoneCode: "",
        stateZoneName: "",
        stateName: "",
        postCode: "",
        phoneNumber: "",
        emailAddr: "",
      },
      addressErrors: {
        addressRegion: "",
        addressFirstName: "",
        addressLastName: "",
        addressLine1: "",
        addressLine2: "",
        addressCity: "",
        addressStateZone: "",
        addressState: "",
        addressPostal: "",
        addressPhone: "",
        guestEmail: "",
      },

      onLoadBillingAddress: {
        id: "",
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        stateZoneCode: "",
        stateZoneName: "",
        stateName: "",
        postCode: "",
        countryCode: "",
        countryName: "",
        phoneNumber: "",
      },
      chosenDeliveryAddress: {
        id: "",
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        stateZoneCode: "",
        stateZoneName: "",
        stateName: "",
        postCode: "",
        countryCode: "",
        countryName: "",
        phoneNumber: "",
      },
      chosenBillingAddress: {
        id: "",
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        stateZoneCode: "",
        stateZoneName: "",
        stateName: "",
        postCode: "",
        countryCode: "",
        countryName: "",
        phoneNumber: "",
      },
      editAddressID: "",
      editAddressCountryCode: "",
      editAddressCountryName: "",
      editAddressFirstName: "",
      editAddressLastName: "",
      editAddressLine1: "",
      editAddressLine2: "",
      editAddressCity: "",
      editAddressStateZoneCode: "",
      editAddressStateZoneName: "",
      editAddressStateName: "",
      editAddressPostCode: "",
      editAddressPhoneNumber: "",
      chosenCountry: "",
      chosenStateZone: "",
      submitEditAddressID: "",
      submitEditAddressCountryCode: "",
      submitEditAddressCountryName: "",
      submitEditAddressFirstName: "",
      submitEditAddressLastName: "",
      submitEditAddressLine1: "",
      submitEditAddressLine2: "",
      submitEditAddressCity: "",
      submitEditAddressStateZoneCode: "",
      submitEditAddressStateZoneName: "",
      submitEditAddressStateName: "",
      submitEditAddressPostCode: "",
      submitEditAddressPhoneNumber: "",
      isEditAddressModalOpen: "",
      checkoutSummaryFixed: "",
      mobileNavFixed: "",
      saveAddressActive: false,
      countryViewField: [],
      stateViewField: [],
      lrcCountries: [],
      auRegionLocales: [],
      auTransactionFeeBanner: false,
      isFieldValid: {
        addressRegion: false,
        addressFirstName: false,
        addressLastName: false,
        addressLine1: false,
        addressLine2: true,
        addressCity: false,
        addressStateZone: false,
        addressState: false,
        addressPostal: false,
        addressPhone: false,
        guestEmail: false,
      },
      openMenu: false,
      bagLoader: false,
      confirmApiLoader: false,
      zonesReady: false,
      zonesCountryId: "",
      promoCodeConfirm: "",
      promoCodeConfirmInput: "",
      taxLabel: "",
      shippingFee: 0,
      shippingSubTotal: 0,
      shippingTotal: 0,
      shippingPreOrderTotal: 0,
      chargeNow: 0,
      shippingTaxFee: 0,
      grandTotal: 0,
      countryProvinceLabel: [],
      provinceLabel: "",
      showAddDelAddressForm: false,
      showAddBilAddressForm: false,
      showAddressForm: false,
      showEditAddressForm: false,
      showDeliveryEditAddressFormID: "",
      countryChanged: false,
      countryTyping: false,
      bagCount: this.props.bagCount,
      availableCount: 0,
      unavailableCount: 0,
      preorderCount: 0,
      partialCount: 0,
      countryCodePick: "",
      unavailablePreview: 0,
      preorderPreview: 0,
      partialPreview: 0,
      availablePreview: 3,
      totalConfirmPreview: 0,
      promoCodeInputFocus: false,
      isChangeCountryModalOpen: "",
      isChangeCountryFormModalOpen: "",
      changeCountryPromptId: "",
      changeCountryPromptCountryCode: "",
      existingPromo: "",
      promoRequest: "",
      isRemoveModalOpen: "",
      isBagRemoveModalOpen: "",
      getItemISBN: "",
      submitGuestEmail: "",
      lastValidGuestEmail: "",
      guestEmailRef: "",
      isGuestRegisterSuccess: false,
      confirmPaymentForm: "",
      editPostCodeIsoCode: "",
      guestSignInRegisterLink: "",
      isRedirectGuestModalShow: "",
      checkout_products: [],
      updateQtyAction: "",
      updateISBN: "",
      updateTitle: "",
      updatePrice: "",
      updateBrand: "",
      updateCategoryOld: "",
      updateCategory: "",
      updateCategory2: "",
      updateCategory3: "",
      updateCategory4: "",
      updateCategory5: "",
      updateType: "",
      updateQty: "",
      updateDiscountedPrice: "",
      updateIndex: "",
      deleteTitle: "",
      deleteISBN: "",
      deletePrice: "",
      deleteBrand: "",
      deleteCategoryOld: "",
      deleteCategory: "",
      deleteCategory2: "",
      deleteCategory3: "",
      deleteCategory4: "",
      deleteCategory5: "",
      deleteType: "",
      deleteQty: "",
      deleteCurrencyCode: "",
      deleteDiscountedPrice: "",
      deleteIndex: "",
      checkout_gtm_fireonce: false,
      promoCodeInputEntered: false,
      applyDiscountCodeOnLoad: true,
      orderDetailsHasValue: false,
      hidePromoFieldOrderDetails: '',
      makeAsDefaultAddress: false,
      isBillingRadioSameClicked: false,
      prevPromoValidButInapplicable: false,
    };

    this.accordionBagRef = React.createRef();
    this.accordionDetailsRef = React.createRef();
    this.accordionPaymentRef = React.createRef();
    this.guestEmailRef = React.createRef();
    this.bagDeleteModalRef = React.createRef();
    this.orderDetailsDeleteModalRef = React.createRef();
    this.addressDeleteModalRef = React.createRef();
    this.signInModalRef = React.createRef();
    this.changeCountryModalRef = React.createRef();
    this.addEditCountryModalRef = React.createRef();
  }
  scrollToBag = () =>
    window.scrollTo({
      behavior: "smooth",
      top: this.accordionBagRef.current.offsetTop + 60,
    });
  scrollToDetails = () =>
    window.scrollTo({
      behavior: "smooth",
      top: this.accordionDetailsRef.current.offsetTop + 60,
    });
  scrollToPayment = () => {
    window.scrollTo({
      behavior: "smooth",
      top: this.accordionPaymentRef.current.offsetTop + 999,
    });
  };
  componentDidUpdate = () => {
    if (this.props.data.isBagUpdated) {
      this.getConfirmAPI();
    }
    if (this.state.zonesReady) {
      let chosenCountryId = this.state.zonesCountryId;
      const stateZoneFiltered = this.state.zones.filter((zone) => zone.zoneCountryId === chosenCountryId);
      const updatedZones = stateZoneFiltered.map((zone) => {
        return {
          label: zone.zoneName,
          value: zone.zoneId,
        };
      });
      updatedZones.sort(sortHandler);
      this.setState(
        {
          zonesReady: false,
          stateZone: updatedZones,
        },
        () => {}
      );
    }
    function sortHandler(a, b) {
      return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
    }
  };
  componentDidMount() {
    // If there is no user session on page load, clear kkUserEmail cookie
    if (!Cookies.get("KK_SESSION_ID")) {
      Cookies.remove("kkUserEmail");
    }

    this.props.currentPage("order-details");

    // Trigger GTM on load of order-details page - event:"begin_checkout"
    this.triggerGTM("checkout_orderDetailsPage");

    if (this.props.isGuestCheckoutBlank()) {
      window.location.href = "./#" + this.props.data.bagPagePath;
    } else {
      this.getConfirmAPI();
      this.getCountriesAPI();
      this.getNonDisplayCountriesAPI();
      this.getCountryProvinceLabelJSON();
      this.getZonesAPI();
      this.getAuCountriesJSON();

      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      //    Postcodes Validation     //
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      axios
        .get(this.state.getPostCodeValidationAPIURL, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.setState({postCodeValidation: response.data}, () => {});
        })
        .catch((error) => {});

      window.addEventListener("scroll", this.listenScrollEvent);
    }
  }
  isAuRegion = () => {
    // AU Transaction Fee Notice banner
    let preferredCountry = Cookies.get("preferredCountry");
    let selectedDeliveryLocale = this.state.chosenDeliveryAddress.countryCode;
    let selectedBillingLocale = this.state.chosenBillingAddress.countryCode;

    let isPreferredCountryAu = this.state.auRegionLocales.some((item) => preferredCountry === item.isoCode2);
    let isDeliveryAddressAu = this.state.auRegionLocales.some((item) => selectedDeliveryLocale === item.id);
    let isBillingAddressAu = this.state.auRegionLocales.some((item) => selectedBillingLocale === item.id);

    if (isPreferredCountryAu || isDeliveryAddressAu || isBillingAddressAu) {
      this.setState({auTransactionFeeBanner: true});
    } else {
      this.setState({auTransactionFeeBanner: false});
    }
  };
  listenScrollEvent = () => {
    if (window.scrollY > 125) {
      this.setState({checkoutSummaryFixed: "checkout-summary-fixed"});
    } else {
      this.setState({checkoutSummaryFixed: ""});
    }
    if (window.scrollY > 160) {
      this.setState({mobileNavFixed: "mobile-nav-fixed"}, () => {});
    } else {
      this.setState({mobileNavFixed: ""}, () => {});
    }
  };

  registerGuestAPI = (payload) => {
    this.setState({bagLoader: true}, () => {
      axios
        .post(this.state.registerGuestAPIURL, querystring.stringify(payload))
        .then((response) => {
          if (response.data.status == "success") {
            this.setState(
              {
                isGuestRegisterSuccess: true,
                guestEmail: Cookies.get("kkUserEmail") || response.data.emailUsed,
                customerId: Cookies.get("KK_CUSTOMER_ID"),
                bagLoader: false,
              },
              () => {
                this.props.guestCustomerId(Cookies.get("KK_CUSTOMER_ID"));

                if(this.state.confirmAddressSummary){
                  // If Guest User already has an address, and they entered a new email address, refresh /order-details API.
                  this.getConfirmAPI();
                }
              }
            );
          } else {
          }
        })
        .catch((error) => {
          this.setState({bagLoader: false});
        });
    });
  };
  getConfirmAPI = (source) => {
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    //         Confirm API         //
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    let availableCount = 0;
    let unavailableCount = 0;
    let preorderCount = 0;
    let partialCount = 0;
    let marketRestrictedCount = 0;

    this.setState(
      {
        confirmApiLoader: true,
        isBagUpdated: false,
        shippingFee: 0,
        shippingSubTotal: 0,
        shippingTotal: 0,
        shippingPreOrderTotal: 0,
        shippingTaxFee: 0,
        chosenDeliveryAddress: {
          id: "",
          firstName: "",
          lastName: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          stateZoneCode: "",
          stateZoneName: "",
          stateName: "",
          postCode: "",
          countryCode: "",
          countryName: "",
          phoneNumber: "",
        },
        onLoadBillingAddress: {
          id: "",
          firstName: "",
          lastName: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          stateZoneCode: "",
          stateZoneName: "",
          stateName: "",
          postCode: "",
          countryCode: "",
          countryName: "",
          phoneNumber: "",
        },
        chosenBillingAddress: {
          id: "",
          firstName: "",
          lastName: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          stateZoneCode: "",
          stateZoneName: "",
          stateName: "",
          postCode: "",
          countryCode: "",
          countryName: "",
          phoneNumber: "",
        },
        showAddressForm: false,
      },
      () => {
        let promoInputRequest = "";
        if (this.state.promoInput) {
          //user promo code input
          promoInputRequest = this.state.promoInput;
        } else if (this.state.promoCodeConfirm) {
          //user has already input valid promo code
          promoInputRequest = "";
        }
        // else if (this.state.promoRequest)
        else if (this.state.applyDiscountCodeOnLoad && (Cookies.get("couponCode") || this.props.data.discountCode || Cookies.get("discountCode"))) {
          //bag api has discountCode value,
          //discountCode cookie has value,
          //or couponCode cookie has value

          promoInputRequest = Cookies.get("couponCode") || this.props.data.discountCode || Cookies.get("discountCode");
        } else {
          promoInputRequest = "";
        }
        axios
          .get(
            this.state.getOrderDetailsAPIURL,
            {
              params: {
                promotionDiscount: promoInputRequest,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            if (response.data.code == 0 || response.data.code > 0) {
              //order-details API has error
              this.setState({
                orderDetailsError: true,
                confirmApiLoader: false,
                bagLoader: false,
                promoCodeInputEntered: false,
                applyDiscountCodeOnLoad: false,
                orderDetailsHasValue: false,
              });
            } else if((response.data.OrderSummary == null) && (response.data.addressSummary)){
              // If addressSummary has value, and product availability and orderSummary is null, load address and shipping details only
              this.clearOrderDetails();
              this.setState(
                {
                  confirmAddressSummary: response.data.addressSummary,
                  confirmShippingSummary: response.data.ShippingSummary,
                  isConfirmApiLoaded: response.data.availableOrder,
                  showAddDelAddressForm: false,
                  showAddBilAddressForm: false,
                  confirmAPIErrors: "",
                  confirmAPIErrorMessage: "",
                  confirmAPIErrorHTML: "",
                  promoInput: "",
                  orderDetailsHasValue: response.data.addressSummary,
                },
                () => {

                  if(!(this.props.data.cart.length > 0)){
                    this.props.getBagAPI();
                  } else {
                    // Remove minibag count from localStorage.
                    localStorage.removeItem("MINIBAG_COUNT");
                  }

                  this.loadAddresses();
                }
              );
            }
            else {
              // If order-details API addresses is empty, load bag API items,
              // or if order-details API products exist, load order-details API items
              // or if order-details API products doesn't exist, load bag API items instead
              this.setOrderItems(response, availableCount, unavailableCount, preorderCount, partialCount, source);
            }
          })
          .catch((error) => {
            if (error.response) {
              const errorCode = error.response.status;
              const errorText = "Error " + errorCode + ". Order details not loaded.";
              const errorMessage = "Order details not loaded.";
              const errorHTML = error.response.data;

              this.setState({
                confirmAPIErrorCode: errorCode,
                confirmAPIErrors: errorText,
                confirmAPIErrorMessage: errorMessage,
                bagLoader: false,
                confirmApiLoader: false,
                confirmAPIErrorHTML: errorHTML,
                orderDetailsHasValue: false,
                isSameAsDelivery: false,
                isBillingRadioSameClicked: false,
                isBillingRadioDifferentClicked: false,
              });
            }
          });
      }
    );
  };
  getCountriesAPI = () => {
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    //        Countries API        //
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    axios
      .get(this.state.getAllCountriesAPIURL, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data[0].isoCode2) {
          this.setState({countries: response.data}, () => {});
        } else {
          this.getCountriesJSON();
        }
      })
      .catch((error) => {
        this.getCountriesJSON();
      });
  };
  getCountriesJSON = () => {
    //if getCountries API returns error, load local countries JSON files
    axios
      .get(this.state.getAllCountriesAPIURL_json, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        this.setState({countries: response.data}, () => {});
      })
      .catch((error) => {});
  };
  getNonDisplayCountriesAPI = () => {
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    // None-Display Countries API  //
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    axios
      .get(this.state.getNonDisplayCountriesAPIURL, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data[0].isoCode2) {
          const getNonDisplayCountries = response.data.map((item) => {
            return {
              id: item.id,
              isoCode2: item.isoCode2,
              name: item.name,
            };
          });

          this.setState({lrcCountries: getNonDisplayCountries}, () => {});
        } else {
          this.getNonDisplayCountriesJSON();
        }
      })
      .catch((error) => {
        this.getNonDisplayCountriesJSON();
      });
  };
  getNonDisplayCountriesJSON = () => {
    //if getCountries API returns error, load local countries JSON files
    axios
      .get(this.state.getNonDisplayCountriesAPIURL_json, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const getNonDisplayCountries = response.data.map((item) => {
          return {
            id: item.id,
            isoCode2: item.isoCode2,
            name: item.name,
          };
        });

        this.setState({lrcCountries: getNonDisplayCountries}, () => {});
      })
      .catch((error) => {});
  };
  getAuCountriesJSON = () => {
    // Get all AU Region Locales
    axios
      .get(this.state.getAUCountriesAPIURL_json, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        this.setState({auRegionLocales: response.data}, () => {
          this.isAuRegion();
        });
      })
      .catch((error) => {});
  };
  getCountryProvinceLabelJSON = () => {
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    // Province Label Per Countries JSON //
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    axios
      .get(this.state.getCountryProvinceLabelAPIURL, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        this.setState({countryProvinceLabel: response.data}, () => {});
      })
      .catch((error) => {});
  };

  getZonesAPI = () => {
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    //        Get Zones API        //
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    this.setState({bagLoader: true}, () => {
      axios
        .get(this.state.getZonesAPIURL, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.setState({zones: response.data.zonesSummary}, () => {
            this.setState({zonesReady: true}, () => {
              this.setState({bagLoader: false});
            });
          });
        })
        .catch((error) => {});
    });
  };

  addAddressAPI = (payload) => {
    let querystring = require("querystring");
    var orderDetailsDelay = 0;
    this.setState({bagLoader: true}, () => {
      axios
        .post(this.state.addAddressAPIURL, querystring.stringify(payload))
        .then((response) => {
          this.setState({
            isAddAddress: true,
          }, () => {
            var newAddressId = response.data[0].id;
            if(this.state.confirmAddressSummary){
              orderDetailsDelay = 0;
            }
            else{
              Cookies.set("shippingAddressId", newAddressId);
              orderDetailsDelay = 1000;
            }
            if(this.state.addAddressType=='billing' && this.state.isBillingRadioDifferentClicked){
              // if user clicks "Use a different address" billing option, call "/api/checkout/billing-address-status" API
              this.changeBillingAddressAPI(newAddressId);
            }
            else{
              setTimeout(() => {
                this.getConfirmAPI();
              }, orderDetailsDelay);
            }
            this.clearAddAddressFields();
            this.clearErrorCodes();
            this.closeAddressSections();
          });
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". Address not added.";

            this.setState({
              bagLoader: false,
              addAddressAPIErrors: errorText,
            });
          }
        });
    });
  };
  editAddressAPI = (payload) => {
    let querystring = require("querystring");
    this.setState({bagLoader: true}, () => {
      axios
        .put(this.state.editAddressAPIURL, querystring.stringify(payload))
        .then((response) => {
          this.getConfirmAPI();
          this.clearAddAddressFields();
          this.clearErrorCodes();
          this.closeAddressSections();
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". Address not edited. Please try again.";

            this.setState({
              bagLoader: false,
              addAddressAPIErrors: errorText,
            });
          }
        });
    });
  };

  deleteAddressAPI = (e) => {
    const currentDeliveryId = this.state.initialAddress;
    const currentBillingId = this.state.initialBilling;
    var newDeliveryIdAfterDelete = "";
    var newBillingIdAfterDelete = "";
    const deleteAddressId = e;
    this.setState({bagLoader: true, isDeleteAddressModalOpen: ""}, () => {
      axios
        .delete(this.state.deleteAddressAPIURL, {params: {id: deleteAddressId}})
        .then((response) => {
          var defaultAddressId = response.data[0].id;

          // Update new delivery address
          if(currentDeliveryId && deleteAddressId){
            if(currentDeliveryId == deleteAddressId){
              // If deleted address is selected delivery address, make defaultAddressId as new delivery address
              newDeliveryIdAfterDelete = defaultAddressId;
            }
            else{
              // Make currentDeliveryId as new delivery address
              newDeliveryIdAfterDelete = currentDeliveryId;
            }
          }
          else{
            newDeliveryIdAfterDelete = defaultAddressId;
          }

          // Update new billing address
          if(currentBillingId && deleteAddressId){
            if(currentBillingId == deleteAddressId){
              // If deleted address is selected billing address, make defaultAddressId as new billing address
              newBillingIdAfterDelete = defaultAddressId;
            }
            else{
              // Make currentBillingId as new billing address
              newBillingIdAfterDelete = currentBillingId;
            }
          }
          else{
            newBillingIdAfterDelete = defaultAddressId;
          }
          
          Cookies.set("shippingAddressId", newDeliveryIdAfterDelete);
          Cookies.set("billingAddressId", newBillingIdAfterDelete);
          setTimeout(() => {
            this.getConfirmAPI("deleteApi");
          }, 1000);
          this.isContinuePaymentValidHandler(); // Check if user can able to Continue to Payment on page load.
          this.clearAddAddressFields();
          this.clearErrorCodes();
          this.closeAddressSections();
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". Address not deleted. Please try again.";

            this.setState({
              bagLoader: false,
              addAddressAPIErrors: errorText,
            });
          }
        });
    });
  };
  changeDeliveryAddressAPI = (newDeliveryAddressId, del) => {
    let shippingAddressCountryId = this.state.chosenDeliveryAddress.countryCode;
    let shippingAddressId = newDeliveryAddressId? newDeliveryAddressId: this.state.chosenDeliveryAddress.id;
    let billingAddressId = this.state.isSameAsDelivery ? this.state.chosenDeliveryAddress.id : this.state.chosenBillingAddress.id;
    let billingToSameAddress = this.state.isSameAsDelivery || shippingAddressId == billingAddressId;

    this.setState({bagLoader: true}, () => {
      axios
        .get(this.state.changeDeliveryAddressAPIURL, {
          params: {
            shippingAddressId: shippingAddressId,
            billingAddressId: billingAddressId,
            billingToSameAddress: billingToSameAddress,
            shippingAddressCountryId: shippingAddressCountryId,
          },
        })

        .then((response) => {
          this.setState({
            isDeliveryOpen: false,
            isBillingOptionsOpen: false,
          }, () => {
            if(del){
              // dont call order-details
            }
            else{
              this.getConfirmAPI();
            }
            this.clearErrorCodes();
            this.closeAddressSections();
          });
        })
        .catch((error) => {
          // this.setState({ bagLoader: false });
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". Delivery address not changed. Please try again.";

            this.setState({
              bagLoader: false,
              addAddressAPIErrors: errorText,
            });
          }
        });
    });
  };

  changeBillingAddressAPI = (newBillingAddressId, del) => {
    let shippingAddressCountryId = this.state.chosenDeliveryAddress.countryCode;
    let shippingAddressId = this.state.chosenDeliveryAddress.id;
    let billingAddressId = newBillingAddressId ? newBillingAddressId : this.state.chosenBillingAddress.id;
    let billingToSameAddress = shippingAddressId == billingAddressId;

    this.setState({bagLoader: true}, () => {
      axios
        .get(this.state.changeBillingAddressAPIURL, {
          params: {
            shippingAddressId: shippingAddressId,
            billingAddressId: billingAddressId,
            billingToSameAddress: billingToSameAddress,
            shippingAddressCountryId: shippingAddressCountryId,
          },
        })

        .then((response) => {
          this.setState({
            isSameAsDelivery: billingToSameAddress,
            isBillingRadioSameClicked: billingToSameAddress? true: false,
            isBillingRadioDifferentClicked: billingToSameAddress? false: true,
            isDeliveryOpen: false,
            isBillingOptionsOpen: false,
          }, () => {
            if(del){
              // dont call order-details
            }
            else{
              this.getConfirmAPI();
            }
            this.clearErrorCodes();
            this.closeAddressSections();
          });
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". Billing address not changed. Please try again.";

            this.setState({
              bagLoader: false,
              addAddressAPIErrors: errorText,
            });
          }
        });
    });
  };
  bagTabToggleHandler = () => {
    const isBagOpen = this.state.isBagOpen;

    if (isBagOpen) {
      this.setState({isBagOpen: false});
    } else {
      this.setState({isBagOpen: true});
    }
  };
  deliveryTabToggleHandler = () => {
    const isDeliveryOpen = this.state.isDeliveryOpen;

    if(this.state.chosenBillingAddress.id){
      if(this.state.chosenDeliveryAddress.id == this.state.chosenBillingAddress.id){
        this.setState({
          isSameAsDelivery: true,
          isBillingRadioSameClicked: true,
          isBillingRadioDifferentClicked: false,
          isBillingOptionsOpen: false,
        });
      }
    }
    else{
      this.setState({
        isBillingRadioSameClicked: false,
        isBillingRadioDifferentClicked: false,
        isBillingOptionsOpen: false,
      });
    }
    this.setState(
      {
        isDeliveryOpen: !isDeliveryOpen,
        showDeliveryEditAddressFormID: "",
        showBillingEditAddressFormID: "",
        showAddDelAddressForm: false,
        showAddBilAddressForm: false,
        addAddressAPIErrors: "",
        addAddressLineShow: false,
        showAddressForm: false,
        makeAsDefaultAddress: false,
      },
      () => {
        this.isContinuePaymentValidHandler();
      }
    );
  };
  shippingTabToggleHandler = () => {
    const isShippingOpen = this.state.isShippingOpen;

    if (isShippingOpen) {
      this.setState({isShippingOpen: false});
    } else {
      this.setState({isShippingOpen: true});
    }
  };

  //PROMO CODES HERE

  updatePromoInputHandler = (e) => {
    this.setState(
      {
        ...this.state.promoInput,
        promoInput: e.target.value,
      },
      () => {
        this.isContinuePaymentValidHandler();
      }
    );
  };
  applyPromoHandler = () => {
    this.setState(
      {
        promoCodeInputFocus: false,
        promoCodeInputEntered: true,
      },
      () => {
        this.submitPromoHandler();
      }
    );
  };
  submitPromoHandler = () => {
    this.getConfirmAPI();
  };
  continueToPaymentHandler = () => {
    this.setState({bagLoader: true}, () => {
      this.confirmPaymentAPI();
    });
  };
  isContinuePaymentValidHandler = () => {
    const continuePaymentEmail = Cookies.get("kkUserEmail") || this.state.submitGuestEmail;
    const continuePaymentDeliveryAddress = this.state.chosenDeliveryAddress.id;
    const continuePaymentBillingAddress = this.state.chosenBillingAddress.id;
    const continuePaymentPromoCode = this.state.promoInput;
    const continuePaymentOrderTotal = this.state.grandTotal;

    if (
      this.isEmailValid(continuePaymentEmail) &&
      this.isDeliveryAddressValid(continuePaymentDeliveryAddress) &&
      this.isBillingAddressValid(continuePaymentBillingAddress) &&
      this.isOrderTotalValid(continuePaymentOrderTotal) &&
      !this.state.unavailableCount > 0 && // Bag should not have Unavailable ISBNs
      !this.state.showAddressForm // Address form should be closed to be able to Continue to Payment
    ) {
      if(continuePaymentDeliveryAddress == continuePaymentBillingAddress){
        if(this.state.isBillingRadioDifferentClicked){
          // Disable Continue to Payment button if "Use a diff billing address" is ticked but user hasn't chose a billing address
          this.setState({
            ...this.state.isContinuePaymentValid,
            isContinuePaymentValid: false,
          });
        }
        else{
          // Enable Continue to Payment button
          this.setState({
            ...this.state.isContinuePaymentValid,
            isContinuePaymentValid: true,
          });
        }
      }
      else{
        // Enable Continue to Payment button
        this.setState({
          ...this.state.isContinuePaymentValid,
          isContinuePaymentValid: true,
        });
      }
    } else {
      // Disable Continue to Payment button
      this.setState({
        ...this.state.isContinuePaymentValid,
        isContinuePaymentValid: false,
      });
    }
  };
  isDeliveryAddressValid = (n) => {
    if (n) {
      return true;
    }
  };
  isBillingAddressValid = (n) => {
    if (n) {
      return true;
    }
  };
  isPromoCodeValid = (n) => {
    if (n) {
      return true;
    }
  };
  isOrderTotalValid = (n) => {
    if (parseInt(n) > 0 || parseFloat(n) > 0) {
      return true;
    }
  };
  showAddressModalHandler = (e) => {
    let addDel = false;
    let addBil = false;
    if (e == "addDeliveryAddress") {
      addDel = true;
    }
    if (e == "addBillingAddress") {
      addBil = true;
    }
    this.setState(
      {
        showAddressForm: true,
        showDeliveryEditAddressFormID: "",
        showAddDelAddressForm: addDel,
        showAddBilAddressForm: addBil,
        showDeliveryEditAddressFormID: 0,
        showBillingEditAddressFormID: 0,
        addAddressField: {
          id: "",
          countryCode: "",
          countryName: "",
          firstName: "",
          lastName: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          stateZoneCode: "",
          stateZoneName: "",
          stateName: "",
          postCode: "",
          phoneNumber: "",
          chosenStateZone: "",
        },
        chosenCountry: "",
        countryChanged: false,
        chosenStateZone: "",
        countryViewField: {
          label: "",
          value: "",
        },
        stateViewField: {
          label: "",
          value: "",
        },
        addressErrors: {
          addressRegion: "",
          addressFirstName: "",
          addressLastName: "",
          addressLine1: "",
          addressLine2: "",
          addressCity: "",
          addressStateZone: "",
          addressState: "",
          addressPostal: "",
          addressPhone: "",
          guestEmail: "",
        },

        isFieldValid: {
          addressRegion: false,
          addressFirstName: false,
          addressLastName: false,
          addressLine1: false,
          addressLine2: true,
          addressCity: false,
          addressStateZone: false,
          addressState: false,
          addressPostal: false,
          addressPhone: false,
        },
        submitAddAddress: {
          id: "",
          customerId: "",
          countryId: "",
          countryCode: "",
          countryName: "",
          firstName: "",
          lastName: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          stateZoneCode: "",
          stateZoneName: "",
          stateName: "",
          postCode: "",
          phoneNumber: "",
          emailAddr: "",
        },
        addAddressAPIErrors: "",
      },
      () => {
        this.allFieldsValid();
        this.isContinuePaymentValidHandler();
      }
    );
  };
  countriesOptionHandler = () => {
    const cf = " (CAR)";
    const ae = " (UAE)";
    const gb = " (UK)";
    const us = " (USA)";
    this.state.countries.map((country, index) => {
      if (country.active) {
        if (country.isoCode2 == "CF") {
          return {
            label: country.name + cf,
            value: country,
            key: index,
          };
        } else if (country.isoCode2 == "AE") {
          return {
            label: country.name + ae,
            value: country,
            key: index,
          };
        } else if (country.isoCode2 == "GB") {
          return {
            label: country.name + gb,
            value: country,
            key: index,
          };
        } else if (country.isoCode2 == "US") {
          return {
            label: country.name + us,
            value: country,
            key: index,
          };
        } else {
          return {
            label: country.name,
            value: country,
            key: index,
          };
        }
      } else return 0;
    });
  };
  hideCountryMenu = () => {
    this.setState({openMenu: false}, () => {
      this.addressFirstNameRef.focus();
    });
  };

  countryInputHandler = (query, {action}) => {
    let inputValue = query;
    let countryId = "";
    let countryCode = "";
    let countryName = "";

    if (action === "input-change") {
      this.setState(
        {
          openMenu: true,
          countryTyping: true,
        },
        () => {}
      );
    }

    this.state.lrcCountries.map((country) => {
      if (inputValue.toUpperCase() == country.name.toUpperCase()) {
        countryName = country.name;
        countryId = country.id;
        countryCode = country.isoCode2;
        this.setState(
          {
            ...this.state,
            zonesReady: true,
            zonesCountryId: countryId,
            countryCodePick: countryCode,
            editPostCodeIsoCode: countryId,
            submitAddAddress: {
              ...this.state.submitAddAddress,
              countryId: countryId,
              countryCode: countryCode,
              countryName: countryName,
            },
            chosenCountry: countryName,
            countryTyping: false,
            countryChanged: true,
            chosenStateZone: "",
            countryViewField: {label: countryName},
            isFieldValid: {
              ...this.state.isFieldValid,
              addressRegion: true,
              addressStateZone: false,
              addressState: false,
              addressPostal: false,
            },
            provinceLabel: "County, State or Province",
            addressErrors: {
              ...this.state.addressErrors,
              addressState: "",
              addressPostal: "",
            },
            addAddressField: {
              ...this.state.addAddressField,
              countryName: countryName,
              stateZoneCode: "",
              stateZoneName: "",
              stateName: "",
              postCode: "",
            },
            addressStateZoneHasValue: "",
            addressStateHasValue: "",
            stateViewField: {
              label: "",
              value: "",
            },
            stateZone: [],
          },
          () => {
            this.countryFocusHandler();
          }
        );
      }
    });
  };
  addModalChangedHandler = (e, field) => {
    let countryId = "";
    let countryCode = "";
    let countryName = "";
    let countryProvinceLabel = "";
    if (field == "addressRegion") {
      countryId = e === null ? "" : e.value.id;
      countryCode = e === null ? "" : e.value.isoCode2;
      countryName = e === null ? "" : e.label;
      countryProvinceLabel = this.state.countryProvinceLabel;
      let provinceLabel = "";
      countryProvinceLabel.map((country) => {
        provinceLabel = country[countryCode];
      });
      this.setState(
        {
          ...this.state,
          zonesReady: true,
          zonesCountryId: countryId,
          countryCodePick: countryCode,
          editPostCodeIsoCode: countryId,
          submitAddAddress: {
            ...this.state.submitAddAddress,
            countryId: countryId,
            countryCode: countryCode,
            countryName: countryName,
          },
          chosenCountry: countryName,
          countryTyping: false,
          countryChanged: true,
          chosenStateZone: "",
          countryViewField: {label: countryName},
          isFieldValid: {
            ...this.state.isFieldValid,
            [field]: true,
            addressStateZone: false,
            addressState: false,
            addressPostal: false,
          },
          provinceLabel: provinceLabel,
          addressErrors: {
            ...this.state.addressErrors,
            addressState: "",
            addressPostal: "",
          },
          addAddressField: {
            ...this.state.addAddressField,
            countryName: countryName,
            stateZoneCode: "",
            stateZoneName: "",
            stateName: "",
            postCode: "",
          },
          addressStateZoneHasValue: "",
          addressStateHasValue: "",
          stateViewField: {
            label: "",
            value: "",
          },
          stateZone: [],
        },
        () => {
          this.countryBlurHandler();
          this.allFieldsValid();
        }
      );
    }
    if (field == "addressStateZone") {
      let stateZoneCode = "";
      let stateZoneName = "";
      stateZoneCode = e === null ? "" : e.value;
      stateZoneName = e === null ? "" : e.label;

      this.setState(
        {
          ...this.state,
          submitAddAddress: {
            ...this.state.submitAddAddress,
            stateZoneCode: stateZoneCode,
            stateZoneName: stateZoneName,
            stateName: stateZoneName,
          },
          addAddressField: {
            ...this.state.addAddressField,
            stateName: stateZoneName,
            stateZoneCode: stateZoneCode,
            stateZoneName: stateZoneName,
          },
          stateViewField: {label: stateZoneName},
          isFieldValid: {
            ...this.state.isFieldValid,
            [field]: stateZoneCode != "",
            addressState: stateZoneCode != "",
          },
          chosenStateZone: "",
        },
        () => this.allFieldsValid()
      );
    }
    if (field == "addressFirstName") {
      const inputValue = e.target.value;

      //Update input state view
      this.setState(
        {
          ...this.state,
          addAddressField: {
            ...this.state.addAddressField,
            firstName: inputValue,
          },
        },
        () => {
          //Update input state submit
          if (this.isValid(inputValue, field)) {
            this.setState(
              {
                ...this.state,
                submitAddAddress: {
                  ...this.state.submitAddAddress,
                  firstName: inputValue,
                },
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: true,
                },
              },
              () => this.allFieldsValid()
            );
          } else {
            this.setState(
              {
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: false,
                },
              },
              () => this.allFieldsValid()
            );
          }
        }
      );
    }
    if (field == "addressLastName") {
      const inputValue = e.target.value;

      //Update input state view
      this.setState(
        {
          ...this.state,
          addAddressField: {
            ...this.state.addAddressField,
            lastName: inputValue,
          },
        },
        () => {
          //Update input state submit
          if (this.isValid(inputValue, field)) {
            this.setState(
              {
                ...this.state,
                submitAddAddress: {
                  ...this.state.submitAddAddress,
                  lastName: inputValue,
                },
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: true,
                },
              },
              () => this.allFieldsValid()
            );
          } else {
            this.setState(
              {
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: false,
                },
              },
              () => this.allFieldsValid()
            );
          }
        }
      );
    }
    if (field == "addressLine1") {
      const inputValue = e.target.value;

      //Update input state view
      this.setState(
        {
          ...this.state,
          addAddressField: {
            ...this.state.addAddressField,
            addressLine1: inputValue,
          },
        },
        () => {
          //Update input state submit
          if (this.isValid(inputValue, field)) {
            this.setState(
              {
                ...this.state,
                submitAddAddress: {
                  ...this.state.submitAddAddress,
                  addressLine1: inputValue,
                },
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: true,
                },
              },
              () => this.allFieldsValid()
            );
          } else {
            this.setState(
              {
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: false,
                },
              },
              () => this.allFieldsValid()
            );
          }
        }
      );
    }

    if (field == "addressLine2") {
      const inputValue = e.target.value;

      //Update input state view
      this.setState(
        {
          ...this.state,
          addAddressField: {
            ...this.state.addAddressField,
            addressLine2: inputValue,
          },
        },
        () => {
          //Update input state submit
          if (this.isValid(inputValue, field)) {
            this.setState(
              {
                ...this.state,
                submitAddAddress: {
                  ...this.state.submitAddAddress,
                  addressLine2: inputValue,
                },
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: true,
                },
              },
              () => this.allFieldsValid()
            );
          } else {
            this.setState(
              {
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: false,
                },
              },
              () => this.allFieldsValid()
            );
          }
        }
      );
    }

    if (field == "addressCity") {
      const inputValue = e.target.value;

      //Update input state view
      this.setState(
        {
          ...this.state,
          addAddressField: {
            ...this.state.addAddressField,
            city: inputValue,
          },
        },
        () => {
          //Update input state submit
          if (this.isValid(inputValue, field)) {
            this.setState(
              {
                ...this.state,
                submitAddAddress: {
                  ...this.state.submitAddAddress,
                  city: inputValue,
                },
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: true,
                },
              },
              () => this.allFieldsValid()
            );
          } else {
            this.setState(
              {
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: false,
                },
              },
              () => this.allFieldsValid()
            );
          }
        }
      );
    }

    if (field == "addressState") {
      const inputValue = e.target.value;

      //Update input state view
      this.setState(
        {
          ...this.state,
          addAddressField: {
            ...this.state.addAddressField,
            stateName: inputValue,
            stateZoneCode: 0,
            stateZoneName: inputValue,
          },
        },
        () => {
          //Update input state submit
          if (this.isValid(inputValue, field)) {
            this.setState(
              {
                ...this.state,
                submitAddAddress: {
                  ...this.state.submitAddAddress,
                  stateName: inputValue,
                  stateZoneCode: 0,
                  stateZoneName: inputValue,
                },
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: true,
                  addressStateZone: true,
                },
              },
              () => this.allFieldsValid()
            );
          } else {
            this.setState(
              {
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: false,
                  addressStateZone: false,
                },
              },
              () => this.allFieldsValid()
            );
          }
        }
      );
    }

    if (field == "addressPostal") {
      const inputValue = e.target.value;

      //Update input state view
      this.setState(
        {
          ...this.state,
          addAddressField: {
            ...this.state.addAddressField,
            postCode: inputValue,
          },
        },
        () => {
          //Update input state submit
          if (this.isValid(inputValue, field)) {
            this.setState(
              {
                ...this.state,
                submitAddAddress: {
                  ...this.state.submitAddAddress,
                  postCode: inputValue,
                },
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: true,
                },
              },
              () => this.allFieldsValid()
            );
          } else {
            this.setState(
              {
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: false,
                },
              },
              () => this.allFieldsValid()
            );
          }
        }
      );
    }

    if (field == "addressPhone") {
      const inputValue = e.target.value;

      //Update input state view
      this.setState(
        {
          ...this.state,
          addAddressField: {
            ...this.state.addAddressField,
            phoneNumber: inputValue,
          },
        },
        () => {
          //Update input state submit
          if (this.isValid(inputValue, field)) {
            this.setState(
              {
                ...this.state,
                submitAddAddress: {
                  ...this.state.submitAddAddress,
                  phoneNumber: inputValue,
                },
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: true,
                },
              },
              () => this.allFieldsValid()
            );
          } else {
            this.setState(
              {
                ...this.state,
                submitAddAddress: {
                  ...this.state.submitAddAddress,
                  phoneNumber: inputValue,
                },
                isFieldValid: {
                  ...this.state.isFieldValid,
                  [field]: false,
                },
              },
              () => this.allFieldsValid()
            );
          }
        }
      );
    }

    if (field == "guestEmail") {
      const inputValue = e.target.value;

      //Update input state view
      this.setState(
        {
          guestEmail: inputValue,
        },
        () => {
          //Update input state submit
          if (this.isValid(inputValue, field)) {
            this.setState({}, () => {
              this.allFieldsValid();
            });
          } else {
            this.setState(
              {
                submitGuestEmail: "",
              },
              () => {
                this.allFieldsValid();
              }
            );
          }
        }
      );
    }

    this.removeFocusHandler(e, field);
  };

  isValid = (inputValue, inputType) => {
    let errors = this.state.addressErrors;
    let isFieldValid = this.state.isFieldValid;
    let val = false;
    let valid = false;

    switch (inputType) {
      case "addressFirstName":
        if (inputValue.length == 0) {
          errors.addressFirstName = "Please enter your first name";
          val = false;
        } else if (!this.isNameCharactersValid(inputValue)) {
          errors.addressFirstName = "Please enter valid characters only";
          val = false;
        } else if (inputValue.length < 2) {
          errors.addressFirstName = "Please enter at least 2 characters";
          val = false;
        } else if (inputValue.length > 32) {
          errors.addressFirstName = "Please enter no more than 32 characters";
          val = false;
        } else {
          errors.addressFirstName = "";
          val = true;
        }
        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {}
        );
        return val;
        break;
      case "addressLastName":
        if (inputValue.length == 0) {
          errors.addressLastName = "Please enter your last name";
          val = false;
        } else if (!this.isNameCharactersValid(inputValue)) {
          errors.addressLastName = "Please enter valid characters only";
          val = false;
        } else if (inputValue.length < 2) {
          errors.addressLastName = "Please enter at least 2 characters";
          val = false;
        } else if (inputValue.length > 32) {
          errors.addressLastName = "Please enter no more than 32 characters";
          val = false;
        } else {
          errors.addressLastName = "";
          val = true;
        }

        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {}
        );
        return val;
        break;
      case "addressLine1":
        if (inputValue.length == 0) {
          errors.addressLine1 = "Please enter your address";
          val = false;
        } else if (!this.isAddressLineCharactersValid(inputValue)) {
          errors.addressLine1 = "Please enter valid characters only";
          val = false;
        } else if (inputValue.length < 2) {
          errors.addressLine1 = "Please enter at least 2 characters";
          val = false;
        } else if (inputValue.length > 64) {
          errors.addressLine1 = "Please enter no more than 64 characters";
          val = false;
        } else {
          errors.addressLine1 = "";
          val = true;
        }

        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {}
        );
        return val;
        break;
      case "addressLine2":
        if (inputValue.length == 0) {
          errors.addressLine2 = "";
          val = true;
        } else if (inputValue.length == 1) {
          errors.addressLine2 = "Please enter at least 2 characters";
          val = false;
        }
        else if (!this.isAddressLineCharactersValid(inputValue)) {
          errors.addressLine2 = "Please enter valid characters only";
          val = false;
        } else if (inputValue.length > 64) {
          errors.addressLine2 = "Please enter no more than 64 characters";
          val = false;
        } else {
          errors.addressLine2 = "";
          val = true;
        }

        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {}
        );
        return val;
        break;
      case "addressCity":
        if (inputValue.length == 0) {
          errors.addressCity = "Please enter your city";
          val = false;
        } else if (!this.isAddressLineCharactersValid(inputValue)) {
          errors.addressCity = "Please enter valid characters only";
          val = false;
        } else if (inputValue.length < 2) {
          errors.addressCity = "Please enter at least 2 characters";
          val = false;
        } else if (inputValue.length > 40) {
          errors.addressCity = "Please enter no more than 40 characters";
          val = false;
        } else {
          errors.addressCity = "";
          val = true;
        }
        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {}
        );
        return val;
        break;
      case "addressState":
        if (inputValue.length == 0) {
          errors.addressState = "Please enter your county, state or province";
          val = false;
        } else if (inputValue.length < 2) {
          errors.addressState = "Please enter at least 2 characters";
          val = false;
        } else if (inputValue.length > 32) {
          errors.addressState = "Please enter no more than 32 characters";
          val = false;
        } else {
          errors.addressState = "";
          val = true;
        }
        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {}
        );
        return val;
        break;
      case "addressPostal":
        if (inputValue.length == 0) {
          errors.addressPostal = "Please enter your post code";
          val = false;
        } else if (inputValue.length < 2) {
          errors.addressPostal = "Please enter at least 2 characters";
          val = false;
        } else if (this.isPostCodeValid(this.state.editPostCodeIsoCode, inputValue)) {
          errors.addressPostal = "";
          val = true;
        } else {
          errors.addressPostal = "Please enter a valid post code";
          val = false;
        }

        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {}
        );
        return val;
        break;
      case "addressPhone":
        if (inputValue.length == 0) {
          errors.addressPhone = "Please enter your phone number";
          val = false;
        } else if (!this.isNumberonly(inputValue)) {
          errors.addressPhone = "Please enter valid characters only (0-9, no special symbols and spaces)";
          val = false;
        } else if (inputValue.length > 32) {
          errors.addressPhone = "Please enter no more than 32 characters";
          val = false;
        } else {
          errors.addressPhone = "";
          val = true;
        }
        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {}
        );
        return val;
        break;
      case "guestEmail":
        if (inputValue.length == 0) {
          errors.guestEmail = "Please enter your email address";
          val = false;
        } else if (!this.isEmailValid(inputValue)) {
          errors.guestEmail = "";
          val = false;
        } else {
          errors.guestEmail = "";
          val = true;
        }
        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {
            this.isContinuePaymentValidHandler();
          }
        );
        return val;
        break;
      default:
        break;
    }
  };
  isValidOnBlur = (inputValue, inputType) => {
    let errors = this.state.addressErrors;
    let val = false;

    switch (inputType) {
      case "guestEmail":
        if (inputValue.length == 0) {
          errors.guestEmail = "Please enter your email address";
          val = false;
        } else if (!this.isEmailValid(inputValue)) {
          errors.guestEmail = "Please enter a valid email address";
          val = false;
        } else {
          errors.guestEmail = "";
          val = true;
        }
        this.setState(
          {
            errors,
            [inputType]: inputValue,
          },
          () => {}
        );
        return val;
        break;
      default:
    }
  };
  allFieldsValid = () => {
    if (
      this.state.isFieldValid.addressRegion &&
      this.state.isFieldValid.addressFirstName &&
      this.state.isFieldValid.addressLastName &&
      this.state.isFieldValid.addressLine1 &&
      this.state.isFieldValid.addressLine2 &&
      this.state.isFieldValid.addressCity &&
      this.state.isFieldValid.addressStateZone &&
      this.state.isFieldValid.addressState &&
      this.state.isFieldValid.addressPostal &&
      this.state.isFieldValid.addressPhone &&
      (this.state.submitGuestEmail || Cookies.get("kkUserEmail")) // if guest email has value or if signed in, user email has value
    ) {
      this.setState({
        saveAddressActive: true,
      });
    } else {
      this.setState({
        saveAddressActive: false,
      });
    }
    // }
  };
  isEmailValid = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };
  inputBlurHandler = (e, field) => {
    if (field == "guestEmail") {
      const inputValue = e.target.value;

      if (inputValue != Cookies.get("kkUserEmail")) {
        //if guest user entered a new email
        //Update input state view
        this.setState(
          {
            guestEmail: inputValue,
          },
          () => {
            //Update input state submit
            if (this.isValidOnBlur(inputValue, field)) {
              this.setState(
                {
                  submitGuestEmail: inputValue,
                },
                () => {
                  if (this.state.lastValidGuestEmail.toUpperCase() != inputValue.toUpperCase()) {
                    this.setState(
                      {
                        lastValidGuestEmail: inputValue,
                      },
                      () => {
                        // call register guest api
                        let payload = {
                          email: inputValue,
                        };
                        this.registerGuestAPI(payload);
                      }
                    );
                  } else {
                  }
                  this.isContinuePaymentValidHandler();
                }
              );
            } else {
              this.setState(
                {
                  submitGuestEmail: "",
                  guestEmail: this.state.lastValidGuestEmail,
                  lastValidGuestEmail: this.state.lastValidGuestEmail,
                },
                () => {
                  this.isContinuePaymentValidHandler();
                }
              );
            }
          }
        );
      }
    }
  };
  removeFocusHandler = (e, field) => {
    const fieldType = field;
    if (fieldType == "addressRegion") {
      const countryValue = e === null ? "" : e.value;

      if (countryValue) {
        this.setState({
          addressRegionHasValue: "hasValue",
        });
      } else {
        this.setState({
          addressRegionHasValue: "",
        });
      }
    } else if (fieldType == "addressStateZone") {
      const stateZonealue = e === null ? "" : e.value;

      if (stateZonealue) {
        this.setState({
          addressStateZoneHasValue: "hasValue",
        });
      } else {
        this.setState({
          addressStateZoneHasValue: "",
        });
      }
    } else {
      const input = e.target.value;
      if (fieldType == "addressFirstName") {
        if (input) {
          this.setState({
            addressFirstNameHasValue: "hasValue",
          });
        } else {
          this.setState({
            addressFirstNameHasValue: "",
          });
        }
      }
      if (fieldType == "addressLastName") {
        if (input) {
          this.setState({
            addressLastNameHasValue: "hasValue",
          });
        } else {
          this.setState({
            addressLastNameHasValue: "",
          });
        }
      }
      if (fieldType == "addressLine1") {
        if (input) {
          this.setState({
            addressLine1HasValue: "hasValue",
          });
        } else {
          this.setState({
            addressLine1HasValue: "",
          });
        }
      }
      if (fieldType == "addressLine2") {
        if (input) {
          this.setState({
            addressLine2HasValue: "hasValue",
          });
        } else {
          this.setState({
            addressLine2HasValue: "",
          });
        }
      }
      if (fieldType == "addressCity") {
        if (input) {
          this.setState({
            addressCityHasValue: "hasValue",
          });
        } else {
          this.setState({
            addressCityHasValue: "",
          });
        }
      }
      if (fieldType == "addressState") {
        if (input) {
          this.setState({
            addressStateHasValue: "hasValue",
          });
        } else {
          this.setState({
            addressStateHasValue: "",
          });
        }
      }
      if (fieldType == "addressPostal") {
        if (input) {
          this.setState({
            addressPostalHasValue: "hasValue",
          });
        } else {
          this.setState({
            addressPostalHasValue: "",
          });
        }
      }
      if (fieldType == "addressPhone") {
        if (input) {
          this.setState({
            addressPhoneHasValue: "hasValue",
          });
        } else {
          this.setState({
            addressPhoneHasValue: "",
          });
        }
      }
      if (fieldType == "guestEmail") {
        if (input || this.state.guestEmail) {
          this.setState({
            guestEmailHasValue: "hasValue",
          });
        } else {
          this.setState({
            guestEmailHasValue: "",
          });
        }
      }
    }
  };
  countryOptionsHandler = () => {
    return this.state.countries.map((country, index) => {
      const cf = " (CAR)";
      const ae = " (UAE)";
      const gb = " (UK)";
      const us = " (USA)";
      if (country.active) {
        if (country.isoCode2 == "CF") {
          return {
            label: country.name + cf,
            value: country,
            key: index,
          };
        } else if (country.isoCode2 == "AE") {
          return {
            label: country.name + ae,
            value: country,
            key: index,
          };
        } else if (country.isoCode2 == "GB") {
          return {
            label: country.name + gb,
            value: country,
            key: index,
          };
        } else if (country.isoCode2 == "US") {
          return {
            label: country.name + us,
            value: country,
            key: index,
          };
        } else {
          return {
            label: country.name,
            value: country,
            key: index,
          };
        }
      } else return 0;
    });
  };
  countryFocusHandler = () => {
    this.setState(
      {
        ...this.state.countryFocus,
        countryFocus: "focused",
      },
      () => {}
    );
  };
  countryBlurHandler = () => {
    let chosenCountry = this.state.chosenCountry;
    let err = "";

    if (chosenCountry == "") {
      err = "Please choose a country";
    } else {
      err = "";
    }
    this.setState(
      {
        addressErrors: {
          ...this.state.addressErrors,
          addressRegion: err,
        },
      },
      () => {
        this.setState(
          {
            countryFocus: "",
            countryTyping: false,
          },
          () => {}
        );
      }
    );
  };
  zoneOptionsHandler = () => {
    return this.state.stateZone.map((zone, index) => {
      if (zone.value) {
        return {
          label: zone.label,
          value: zone.value,
          key: index,
        };
      } else return 0;
    });
  };
  stateZoneFocusHandler = () => {
    this.setState(
      {
        ...this.state.stateZoneFocus,
        stateZoneFocus: "focused",
      },
      () => {}
    );
  };
  stateZoneBlurHandler = () => {
    this.setState(
      {
        stateZoneFocus: "",
      },
      () => {}
    );
  };
  addAddressLineModalHandler = () => {
    this.setState({
      ...this.state.addAddressLineShow,
      addAddressLineShow: true,
    });
  };
  addAddressModalHandler = (type) => {
    this.setState({
      addAddressType: type,
    }, () => {
      const currentCountry = this.state.chosenDeliveryAddress.countryCode;
      const newCountry = this.state.submitAddAddress.countryId;
  
      this.saveAddress();
    });
  };

  saveAddress = () => {
    const editID = this.state.submitAddAddress.id;

    this.setState(
      {
        isChangeCountryFormModalOpen: "",
      },
      () => {
        if (
          this.state.submitAddAddress.countryId &&
          this.state.submitAddAddress.firstName &&
          this.state.submitAddAddress.lastName &&
          this.state.submitAddAddress.addressLine1 &&
          this.state.submitAddAddress.city &&
          this.state.submitAddAddress.postCode &&
          this.state.submitAddAddress.stateZoneCode != null &&
          this.state.submitAddAddress.stateZoneName != null &&
          this.state.submitAddAddress.stateName != null
        ) {
          const submitSaveAddress = this.state.submitAddAddress;
          const submitCustomerID = Cookies.get("KK_CUSTOMER_ID");
          const submitEmail = this.state.customerEmail || this.state.guestEmail;
          let payload = {};
          if (editID) {
            payload = {
              id: submitSaveAddress.id,
              customerId: submitCustomerID,
              country: submitSaveAddress.countryId,
              firstName: submitSaveAddress.firstName,
              lastName: submitSaveAddress.lastName,
              company: "",
              streetAddress: submitSaveAddress.addressLine1,
              streetAddress1: submitSaveAddress.addressLine2,
              city: submitSaveAddress.city,
              state: submitSaveAddress.stateName,
              zoneId: submitSaveAddress.stateZoneCode,
              postCode: submitSaveAddress.postCode,
              telephoneNumber: submitSaveAddress.phoneNumber,
              email: submitEmail,
              isPrimary: this.state.makeAsDefaultAddress,
              selectedBillingAddress: this.state.addAddressType=='billing' && this.state.isBillingRadioDifferentClicked ? true : false,
            };

            this.setState({bagLoader: true}, () => {
              this.editAddressAPI(payload);
            });
          } else {
            payload = {
              country: submitSaveAddress.countryId,
              firstName: submitSaveAddress.firstName,
              lastName: submitSaveAddress.lastName,
              company: "",
              streetAddress: submitSaveAddress.addressLine1,
              streetAddress1: submitSaveAddress.addressLine2,
              city: submitSaveAddress.city,
              state: submitSaveAddress.stateName,
              zoneId: submitSaveAddress.stateZoneCode,
              postCode: submitSaveAddress.postCode,
              telephoneNumber: submitSaveAddress.phoneNumber,
              email: submitEmail,
              isPrimary: !this.state.confirmAddressSummary? true : this.state.makeAsDefaultAddress,
              selectedBillingAddress: this.state.addAddressType=='billing' && this.state.isBillingRadioDifferentClicked ? true : false,
            };
            this.setState({bagLoader: true}, () => {
              this.addAddressAPI(payload);
            });
          }
        }
      }
    );
  };
  clearAddAddressFields = () => {
    this.setState(
      {
        addAddressField: {
          id: "",
          countryCode: "",
          countryName: "",
          stateZoneCode: "",
          stateZoneName: "",
          stateName: "",
          firstName: "",
          lastName: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          postCode: "",
          phoneNumber: "",
        },
        chosenCountry: "",
        countryViewField: {
          label: "",
          value: "",
        },
        stateViewField: {
          label: "",
          value: "",
        },
        addressErrors: {
          addressRegion: "",
          addressFirstName: "",
          addressLastName: "",
          addressLine1: "",
          addressLine2: "",
          addressCity: "",
          addressStateZone: "",
          addressState: "",
          addressPostal: "",
          addressPhone: "",
          guestEmail: "",
        },
        stateZone: [],
        addressRegionHasValue: "",
        addressFirstNameHasValue: "",
        addressLastNameHasValue: "",
        addressLine1HasValue: "",
        addressLine2HasValue: "",
        addressCityHasValue: "",
        addressStateZoneHasValue: "",
        addressStateHasValue: "",
        addressPostalHasValue: "",
        addressPhoneHasValue: "",
        submitAddAddress: {
          id: "",
          countryCode: "",
          countryName: "",
          stateZoneCode: "",
          stateZoneName: "",
          firstName: "",
          lastName: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          postCode: "",
          phoneNumber: "",
        },
        isFieldValid: {
          addressRegion: false,
          addressFirstName: false,
          addressLastName: false,
          addressLine1: false,
          addressLine2: true,
          addressCity: false,
          addressStateZone: false,
          addressPostal: false,
          addressPhone: false,
        },
        saveAddressActive: false,
        addAddressLineShow: false,
        provinceLabel: "",
        showDeliveryEditAddressFormID: "",
        showBillingEditAddressFormID: "",
        showAddDelAddressForm: false,
        showAddBilAddressForm: false,
        addAddressAPIErrors: "",
        addAddressLineShow: false,
        isChangeCountryFormModalOpen: "",
      },
      () => {}
    );
  };
  closeAddressModalHandler = () => {
    this.setState(
      {
        showDeliveryEditAddressFormID: "",
        showBillingEditAddressFormID: "",
        showAddDelAddressForm: false,
        showAddBilAddressForm: false,
        addAddressAPIErrors: "",
        addAddressLineShow: false,
        showAddressForm: false,
        makeAsDefaultAddress: false,
      },
      () => {
        this.isContinuePaymentValidHandler();
      }
    );
  };

  updateSelectedBillingAddress = (
    e,
    id,
    firstName,
    lastName,
    addressLine1,
    addressLine2,
    city,
    stateZoneCode,
    stateZoneName,
    stateName,
    postCode,
    countryCode,
    countryName,
    phoneNumber
  ) => {
    const billingAddressId = e.target.value;
    // Get ID of Billing Address chosen
    if (e.target.checked) {
      this.setState(
        {
          ...this.state,
          defaultBillingAddressID: billingAddressId,

          chosenBillingAddress: {
            id: id,
            firstName: firstName,
            lastName: lastName,
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            city: city,
            stateZoneCode: stateZoneCode,
            stateZoneName: stateZoneName,
            stateName: stateName,
            postCode: postCode,
            countryCode: countryCode,
            countryName: countryName,
            phoneNumber: phoneNumber,
          },
        },
        () => {
          this.changeBillingAddressAPI();
        }
      );
    }
  };
  updateSelectedDeliveryAddress = (
    e,
    id,
    countryCode,
  ) => {
    if (countryCode != this.state.chosenDeliveryAddress.countryCode) {
      e.preventDefault();
    } else {
      // Get ID of Delivery Address chosen
      if (e.target.checked) {
        if (this.state.isSameAsDelivery) {
          this.setState(
            {
              ...this.state,
              chosenDeliveryAddress: {
                id: id,
                countryCode: countryCode,
              },

              chosenBillingAddress: {
                id: id,
                countryCode: countryCode,
              },
            },
            () => {
              this.changeDeliveryAddressAPI();
            }
          );
        } else {
          this.setState(
            {
              ...this.state,
              chosenDeliveryAddress: {
                id: id,
                countryCode: countryCode,
              },
            },
            () => {
              this.changeDeliveryAddressAPI();
            }
          );
        }
      }
    }
  };

  changeCountryPrompt = (
    e,
    id,
    countryCode,
  ) => {
    e.preventDefault();
    // Store address to temp state on Change Country Warning Modal
    this.setState(
      {
        isChangeCountryModalOpen: "isOpen",
        changeCountryPromptId: id,
        changeCountryPromptCountryCode: countryCode,
      },
      () => {
        this.changeCountryModalRef.current.focus();
      }
    );
  };
  continueChangeCountry = () => {
    this.setState(
      {
        ...this.state,
        chosenDeliveryAddress: {
          id: this.state.changeCountryPromptId,
          countryCode: this.state.changeCountryPromptCountryCode,
        },
        isChangeCountryModalOpen: "",
      },
      () => {
        this.changeDeliveryAddressAPI();
      }
    );
  };
  showEditAddressHandler = (
    editAddressID,
    editAddresscustomerId,
    editAddressCountryCode,
    editAddressCountryName,
    editAddressFirstName,
    editAddressLastName,
    editAddressLine1,
    editAddressLine2,
    editAddressCity,
    editAddressStateZoneCode,
    editAddressStateZoneName,
    editAddressStateName,
    editAddressPostCode,
    editAddressPhoneNumber,
    editAddressEmail,
    editAddressType
  ) => {
    let delID = 0;
    let bilID = 0;
    if (editAddressType == "delivery") {
      delID = editAddressID;
      bilID = 0;
    }
    if (editAddressType == "billing") {
      delID = 0;
      bilID = editAddressID;
    }
    this.setState(
      {
        zonesReady: true,
        zonesCountryId: editAddressCountryCode,
        showDeliveryEditAddressFormID: delID,
        showBillingEditAddressFormID: bilID,
        showAddDelAddressForm: false,
        showAddBilAddressForm: false,
        showAddressForm: true,
        showEditAddressForm: true,
        addAddressLineShow: false,
        addAddressField: {
          id: editAddressID,
          countryCode: editAddressCountryCode,
          countryName: editAddressCountryName,
          firstName: editAddressFirstName,
          lastName: editAddressLastName,
          addressLine1: editAddressLine1,
          addressLine2: editAddressLine2,
          city: editAddressCity,
          stateZoneCode: editAddressStateZoneCode,
          stateZoneName: editAddressStateZoneName,
          stateName: editAddressStateName,
          postCode: editAddressPostCode,
          phoneNumber: editAddressPhoneNumber,
          chosenStateZone: editAddressStateName,
        },
        chosenCountry: editAddressCountryName,
        countryChanged: false,
        submitAddAddress: {
          id: editAddressID,
          customerId: editAddresscustomerId,
          countryId: editAddressCountryCode,
          countryCode: editAddressCountryCode,
          countryName: editAddressCountryName,
          firstName: editAddressFirstName,
          lastName: editAddressLastName,
          addressLine1: editAddressLine1,
          addressLine2: editAddressLine2,
          city: editAddressCity,
          stateZoneCode: editAddressStateZoneCode,
          stateZoneName: editAddressStateZoneName,
          stateName: editAddressStateName,
          postCode: editAddressPostCode,
          phoneNumber: editAddressPhoneNumber,
          emailAddr: editAddressEmail,
        },
        chosenCountry: "",
        chosenStateZone: editAddressStateName,
        countryViewField: {
          label: "",
          value: "",
        },
        stateViewField: {
          label: "",
          value: "",
        },
        addressErrors: {
          addressRegion: "",
          addressFirstName: "",
          addressLastName: "",
          addressLine1: "",
          addressLine2: "",
          addressCity: "",
          addressStateZone: "",
          addressState: "",
          addressPostal: "",
          addressPhone: "",
          guestEmail: "",
        },

        isFieldValid: {
          addressRegion: true,
          addressFirstName: true,
          addressLastName: true,
          addressLine1: true,
          addressLine2: true,
          addressCity: true,
          addressStateZone: true,
          addressState: true,
          addressPostal: true,
          addressPhone: true,
        },
      },
      () => {
        this.allFieldsValid();
        this.setState(
          {
            isEditAddressModalOpen: "isOpen",
          },
          () => {
            this.setState({editPostCodeIsoCode: this.state.addAddressField.countryCode}, () => {
              this.isContinuePaymentValidHandler();
            });
          }
        );
      }
    );
  };
  closeEditAddressModalHandler = () => {
    this.setState(
      {
        ...this.state,
        isEditAddressModalOpen: "",
      },
      () => {}
    );
  };

  isDeleteAddressModalOpenHandler = (e) => {
    this.setState({
      addressDeleteId: e,
    });
    this.setState(
      {
        isDeleteAddressModalOpen: "isOpen",
      },
      () => {
        this.addressDeleteModalRef.current.focus();
      }
    );
  };
  closedeleteAddressModal = (event) => {
    this.setState({
      isDeleteAddressModalOpen: "",
      addAddressAPIErrors: "",
    });
  };
  closeChangeCountryModal = (event) => {
    this.setState({
      isChangeCountryModalOpen: "",
      isChangeCountryFormModalOpen: "",
      addAddressAPIErrors: "",
    });
  };
  handleKeyDown = (e, editID, addressType) => {
    if (e.key === "Enter") {
      if (addressType == "delivery") {
        this.setState({
          showEditAddressForm: true,
          showDeliveryEditAddressFormID: editID,
          showBillingEditAddressFormID: 0,
        });
      }
      if (addressType == "billing") {
        this.setState({
          showEditAddressForm: true,
          showDeliveryEditAddressFormID: 0,
          showBillingEditAddressFormID: editID,
        });
      }
    }
  };
  bagLoaderHandler = () => {
    this.setState({bagLoader: true});
  };
  isCountryRegexExist = (countrycode) => {
    const postCodeValidation = this.state.postCodeValidation;
    return postCodeValidation.some((country) => country.countryCode === countrycode);
  };
  isPostCodeValid = (countryid, postcode) => {
    const postalCodes = require("postal-codes-js");
    let countryCode = ""; // ISO 3166-1 alpha-2 or alpha-3 country code as string.
    const postalCode = postcode; // Postal code as string or number.

    this.state.countries.map((country, index) => {
      if (countryid == country.id) {
        countryCode = country.isoCode2;
      }
    });
    if (postalCodes.validate(countryCode.toString(), postalCode.toString()) == true) {
      return true;
    }
  };
  isAddressLineCharactersValid = (inputvalue) => {
    const regexp = /((?!(&|%|<|=)).)+$/;
    let isValid = false;
    var found = regexp.test(inputvalue);
    if (found) {
      isValid = true;
    }

    return isValid;
  };
  isNameCharactersValid = (inputvalue) => {
    const regexp = /((?!(&|%|<|=)).)+$/;
    let isValid = false;
    var found = regexp.test(inputvalue);
    if (found) {
      isValid = true;
    }

    return isValid;
  };
  isLetterNumberSpaceOnly = (inputvalue) => {
    const regexp = /^[A-Za-z0-9][A-Za-z0-9 ]*$/;
    let isValid = false;
    var found = regexp.test(inputvalue);
    if (found) {
      isValid = true;
    }

    return isValid;
  };
  isNumberonly = (inputvalue) => {
    const regexp = /^[0-9]*$/;
    let isValid = false;

    var found = regexp.test(inputvalue);
    if (found) {
      isValid = true;
    }

    return isValid;
  };
  showBagPreview = (availableCount, unavailableCount, preorderCount) => {
    let unavailablePreview = 0;
    let preorderPreview = 0;
    let partialPreview = 0;
    let availablePreview = 0;
    let totalConfirmPreview = 0;
    let partialCount = this.state.partialCount;

    if (availableCount >= 1 && preorderCount >= 1 && unavailableCount >= 1) {
      availablePreview = 1;
      preorderPreview = 1;
      unavailablePreview = 1;
    } else if (availableCount >= 2 && preorderCount >= 1) {
      availablePreview = 2;
      preorderPreview = 1;
      unavailablePreview = 0;
    } else if (availableCount >= 2 && preorderCount == 1) {
      availablePreview = 2;
      preorderPreview = 1;
      unavailablePreview = 0;
    } else if (availableCount == 1 && preorderCount >= 2) {
      availablePreview = 1;
      preorderPreview = 2;
      unavailablePreview = 0;
    } else if (availableCount == 1 && preorderCount >= 1 && unavailableCount == 0) {
      availablePreview = 1;
      preorderPreview = 2;
      unavailablePreview = 0;
    } else if (availableCount == 1 && preorderCount == 0 && unavailableCount >= 1) {
      availablePreview = 1;
      preorderPreview = 0;
      unavailablePreview = 2;
    } else if (availableCount >= 2 && preorderCount == 0 && unavailableCount >= 1) {
      availablePreview = 2;
      preorderPreview = 0;
      unavailablePreview = 1;
    } else if (availableCount >= 1 && preorderCount == 0 && unavailableCount == 0) {
      availablePreview = 3;
      preorderPreview = 0;
      unavailablePreview = 0;
    } else if (availableCount == 1 && preorderCount == 0 && unavailableCount >= 1) {
      availablePreview = 1;
      preorderPreview = 0;
      unavailablePreview = 2;
    } else if (availableCount == 0 && preorderCount >= 2 && unavailableCount == 0) {
      availablePreview = 0;
      preorderPreview = 3;
      unavailablePreview = 0;
    } else if (availableCount == 0 && preorderCount >= 2) {
      availablePreview = 0;
      preorderPreview = 2;
      unavailablePreview = 1;
    } else if (availableCount == 0 && preorderCount == 1) {
      availablePreview = 0;
      preorderPreview = 1;
      unavailablePreview = 2;
    } else if (availableCount == 0 && preorderCount == 0 && unavailableCount >= 1) {
      availablePreview = 0;
      preorderPreview = 0;
      unavailablePreview = 3;
    } else {
      availablePreview = 1;
      preorderPreview = 1;
      unavailablePreview = 1;
    }
    totalConfirmPreview = unavailableCount + preorderCount + partialCount + availableCount;

    this.setState(
      {
        unavailablePreview: unavailablePreview,
        preorderPreview: preorderPreview,
        partialPreview: partialPreview,
        availablePreview: availablePreview,
        totalConfirmPreview: totalConfirmPreview,
      });
  };
  promoCodeInputFocusHandler = () => {
    this.setState({
      promoCodeInputFocus: true,
    });
  };
  promoCodeInputBlurHandler = () => {
    this.setState({
      promoCodeInputFocus: false,
    });
  };

  updateMiniCartApi = () => {
    axios
      .post(this.state.updateMiniCartAPIURL)
      .then((response) => {})
      .catch((error) => {
        this.setState({bagLoader: false});
      });
  };
  deleteCartApi = (isbn, src) => {
    // Delete item from cart
    this.setState({
      bagLoader: true,
    },()=>{
      axios
        .delete(this.state.removeBagAPIURL, {params: {isbn: isbn}})
        .then((response) => {
          this.setState({
            bagLoader: false,
          },()=>{
            this.triggerGTM("removeFromCart");
            this.updateMiniCartApi();

            if(src=='bag'){
              this.props.getBagAPI("updatedFromConfirm");
            }
            else if(src=='order-details'){
              this.getConfirmAPI();
            }
          });
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". ISBN " + isbn + " not deleted. Please try again.";
  
            this.setState({
              bagLoader: false,
              addAddressAPIErrors: errorText,
            });
          }
        });
      });
  };

  updateCartQuantityApi = (isbnNumber, quantity) => {
    this.setState({bagLoader: true}, () => {
      axios
        .put(this.state.updateBagAPIURL, null, {
          params: {
            isbn: isbnNumber,
            qty: quantity,
          },
        })
        .then((response) => {
          this.triggerGTM("updateCartQty");
          this.updateMiniCartApi();
          this.getConfirmAPI();
        })
        .catch((error) => {
          if (error.response) {
            const errorCode = error.response.status;
            const errorText = "Error " + errorCode + ". ISBN " + isbnNumber + " quantity not updated. Please try again.";

            this.setState({
              bagLoader: false,
              addAddressAPIErrors: errorText,
            });
          }
        });
    });
  };
  showConfirmModalHandler = (
    event,
    id,
    title,
    price,
    brand,
    category,
    subject,
    learningStage,
    qualification,
    series,
    type,
    quantity,
    discountedPrice,
    index
  ) => {
    this.setState(
      {
        isRemoveModalOpen: "isOpen",
        getItemISBN: id,
        deleteTitle: title,
        deleteISBN: id,
        deletePrice: price,
        deleteBrand: brand,
        deleteCategoryOld: category,
        deleteCategory: subject,
        deleteCategory2: learningStage,
        deleteCategory3: qualification,
        deleteCategory4: type,
        deleteCategory5: series,
        deleteType: type,
        deleteQty: quantity,
        deleteDiscountedPrice: discountedPrice,
        deleteIndex: index
      },
      () => {
        this.orderDetailsDeleteModalRef.current.focus();
      }
    );
  };
  showBagConfirmModalHandler = (
    event,
    id,
    title,
    price,
    brand,
    category,
    subject,
    learningStage,
    qualification,
    series,
    type,
    quantity,
    currencyCode,
    discountedPrice,
    index
  ) => {
    this.setState(
      {
        isBagRemoveModalOpen: "isOpen",
        getItemISBN: id,
        deleteTitle: title,
        deleteISBN: id,
        deletePrice: price,
        deleteBrand: brand,
        deleteCategoryOld: category,
        deleteCategory: subject,
        deleteCategory2: learningStage,
        deleteCategory3: qualification,
        deleteCategory4: type,
        deleteCategory5: series,
        deleteType: type,
        deleteQty: quantity,
        deleteCurrencyCode: currencyCode,
        deleteDiscountedPrice: discountedPrice,
        deleteIndex: index
      },
      () => {
        this.bagDeleteModalRef.current.focus();
      }
    );
  };
  closeConfirmModalHandler = (event) => {
    this.setState(
      {
        isRemoveModalOpen: "",
        isBagRemoveModalOpen: "",
        isRedirectGuestModalShow: "",
      },
      () => {
        Cookies.remove("customRedirect");
      }
    );
  };

  deleteItemHandler = (src) => {
    // Delete item from cart
    const isbn = this.state.getItemISBN;
    this.deleteCartApi(isbn, src);
    this.closeConfirmModalHandler();
  };

  changeQuantityHandler = (event, isbn, title, price, brand, category, subject, learningStage, qualification, series, type, quantity, discountedPrice, index) => {
    const counter = parseInt(event.target.value);
    const computedQty = quantity > counter ? parseInt(quantity) - parseInt(counter) : parseInt(counter) - parseInt(quantity);
    const gtmQtyAction = quantity > counter ? "removeFromCart" : "addToCart";

    this.setState(
      {
        updateQtyAction: gtmQtyAction,
        updateISBN: isbn,
        updateTitle: title,
        updatePrice: price,
        updateBrand: brand,
        updateCategoryOld: category,
        updateCategory: subject,
        updateCategory2: learningStage,
        updateCategory3: qualification,
        updateCategory4: type,
        updateCategory5: series,
        updateType: type,
        updateQty: computedQty,
        updateDiscountedPrice: discountedPrice,
        updateIndex: index
      },
      () => {
        this.updateCartQuantityApi(isbn, counter);
      }
    );
  };

  confirmPaymentAPI = () => {
    axios
      .post(this.state.confirmPaymentAPIURL)
      .then((response) => {
        this.triggerGTM("checkout_continuePayment");
        this.setState({confirmPaymentForm: response.data}, () => {
          let submitPaymentForm = document.querySelectorAll(".pci-redirect-obj-form .submit-btn");
          if (submitPaymentForm && submitPaymentForm.length) {
            submitPaymentForm[0].click();
          }
        });
      })
      .catch((error) => {
        this.setState({bagLoader: false});
      });
  };
  keypressHandler = (event) => {
    if (event.key === "Enter") {
      this.guestEmailRef.current.blur();
    }
  };
  confirmRedirect = (e, link) => {
    e.preventDefault();
    this.setState(
      {
        guestSignInRegisterLink: link,
        isRedirectGuestModalShow: "isOpen",
      },
      () => {
        this.signInModalRef.current.focus();
      }
    );
    this.setCookies("/checkout/#" + this.props.data.checkoutPagePath);
  };
  signInRedirectHandler = () => {
    this.setCookies("/checkout/#" + this.props.data.checkoutPagePath);
  };
  setCookies = (e) => {
    Cookies.set("customRedirect", e);
  };
  clearErrorCodes = () => {
    this.setState({addAddressAPIErrors: ""});
  };
  closeAddressSections = () => {
    this.setState({
      isDeliveryOpen: false,
      isBillingOptionsOpen: false,
    });
  }
  triggerGTM = (action) => {
    if (window["google_tag_manager"] && window["google_tag_manager"][gtmId] && window["google_tag_manager"][gtmId].dataLayer) {
      window["google_tag_manager"][gtmId].dataLayer.reset();
    }

    switch (action) {
      case "checkout_orderDetailsPage":
        // ------------------- on load checkout page (order-details api) ------------------- //

        let checkout_products = [];
        if(this.state.confirmAvailable || this.state.confirmPreorder || this.state.confirmPartial || this.state.confirmMarketRestricted || this.state.confirmUnavailable){
          checkout_products = [
            ...this.state.confirmAvailable,
            ...this.state.confirmPreorder,
            ...this.state.confirmPartial,
            ...this.state.confirmMarketRestricted,
            ...this.state.confirmUnavailable,
          ];
        }
        else{
          checkout_products = [...this.props.data.cart];
        }

        var stream;
        const updatedItems = checkout_products.map((item, index) => {
          if (index == 0) {
            stream = item.gtm.brand;
          }
          return {
            item_id: item.isbn,                       // The ID of the item, in our case ISBN
            item_name: item.title,                    // The name of the item
            affiliation: "Cambridge", // A product affiliation to designate a supplying company or brick and mortar store location. In our case, Cambridge
            coupon: this.state.promoCodeConfirm ? this.state.promoCodeConfirm : this.props.data.discountCode,         // The coupon name/code associated with the item.
            currency: this.state.confirmCurrencyCode, // Currency of the items associated with the event
            discount: item.discountedPrice ? (parseFloat(item.price - item.discountedPrice)) : 0.00, // The monetary discount value associated with the item.
            index: index,                             // The index/position of the item in a list.
            item_brand: item.gtm.brand,               // The brand of the item. In our case academic, education or cambridge english
            item_category: (typeof item.subject !== "undefined") ? item.subject : "", // Subject
            item_category2: (typeof item.learningStage !== "undefined") ? item.learningStage : "", // Learning Stage
            item_category3: (typeof item.qualification !== "undefined") ? item.qualification : "", // Qualification
            item_category4: (typeof item.type !== "undefined") ? item.type : "", // Format
            item_category5: (typeof item.series !== "undefined") ? item.series : "", // Series Name
            item_list_id: "",                         // The ID of the list in which the item was presented to the user. We may not be using this.
            item_list_name: this.props.data.currentPage,   // The name of the list in which the item was presented to the user. In this case Bag List
            item_variant: item.gtm.variant,           // The item variant or unique code or description for additional item details/options.
            location_id: "",                          // The physical location associated with the item (e.g. the physical store location) NA
            price: parseFloat(item.price),                        // The monetary price of the item, in units of the specified currency parameter.
            quantity: item.quantity,                  // Item quantity.
          };
        });
        this.setState(
          {
            checkout_products: updatedItems,
          },
          () => {
            const tagManagerArgs_checkout = {
              gtmId: gtmId,
              dataLayer: {
                event: "begin_checkout", // name of an event. In this case, always stays as begin_checkout
                ecommerce: {
                  // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                  items: this.state.checkout_products, // list of products a user had in a cart before entering the checkout
                },
                stream: stream
              },
            };

            if (typeof Cookies.get("GIGYA_UID") !== "undefined") {
              const tagManagerArgs_userId = {
                gtmId: gtmId,
                dataLayer: {
                  userId: Cookies.get("GIGYA_UID")
                },
              };

              TagManager.dataLayer(tagManagerArgs_userId);
            }

            TagManager.dataLayer(tagManagerArgs_checkout);
          }
        );
        // );
        break;
      case "updateCartQty":
        // ------------------- on item quantity update from bag ------------------- //

        const updateQty_list = this.props.data.currentPage;
        const updateQty_name = this.state.updateTitle;
        const updateQty_id = this.state.updateISBN;
        const updateQty_price = this.state.updatePrice;
        const updateQty_brand = this.state.updateBrand;
        const updateQty_category_old = this.state.updateCategoryOld;
        const updateQty_category = this.state.updateCategory;
        const updateQty_category2 = this.state.updateCategory2;
        const updateQty_category3 = this.state.updateCategory3;
        const updateQty_category4 = this.state.updateCategory4;
        const updateQty_category5 = this.state.updateCategory5;
        const updateQty_variant = this.state.updateType;
        const updateQty_quantity = this.state.updateQty;
        const updateQty_currency = this.state.confirmCurrencyCode || this.state.deleteCurrencyCode;
        const updateQty_discountedPrice = this.state.updateDiscountedPrice;
        const updateQty_index = this.state.updateIndex;
        let tagManagerArgs_updateQty_GA3 = "";
        let tagManagerArgs_updateQty_GA4 = "";

        if (this.state.updateQtyAction == "addToCart") {
          // GA3 Add To Cart Using Dropdown
          tagManagerArgs_updateQty_GA3 = {
            gtmId: gtmId,
            dataLayer: {
              event: "addToCart", // name of an event. In this case, always stays as addToCart
              ecommerce: {
                // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                currencyCode: updateQty_currency, // the currency which is currently used by a visitor
                add: {
                  // name of an action. In this case, always stays as add
                  actionField: {
                    list: updateQty_list, // optional. name of a list from which the product was added to a cart
                  },
                  products: [
                    {
                      // list of products added to a cart. Can contain multiple products at the same time
                      name: updateQty_name, // name of a product that was added to a cart
                      id: updateQty_id, // id of a product
                      price: updateQty_price, // price of a product
                      brand: updateQty_brand, // brand/vendor of a product
                      category: updateQty_category_old, // category of a product
                      variant: updateQty_variant, // product variant. If there are no variants, exclude this key from the dataLayer.push
                      quantity: updateQty_quantity, // Item quantity.
                    },
                  ],
                },
              },
            },
          };

          // GA4 Add To Cart Using Dropdown
          tagManagerArgs_updateQty_GA4 = {
            gtmId: gtmId,
            dataLayer: {
              event: "add_to_cart", // name of an event. In this case, always stays as add_to_cart
              ecommerce: { // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                items: [ // The items for the event - this is an array
                  {
                    item_id: updateQty_id, // The ID of the item, in our case ISBN
                    item_name: updateQty_name, // The name of the item
                    affiliation: "Cambridge", // A product affiliation to designate a supplying company or brick and mortar store location. In our case, Cambridge
                    coupon: this.state.promoCodeConfirm ? this.state.promoCodeConfirm : this.props.data.discountCode, // The coupon name/code associated with the item.
                    currency: updateQty_currency, // Currency of the items associated with the event
                    discount: updateQty_discountedPrice ? (parseFloat(updateQty_price - updateQty_discountedPrice)) : 0.00, // The monetary discount value associated with the item.
                    index: updateQty_index, // The index/position of the item in a list.
                    item_brand: updateQty_brand, // The brand of the item. In our case academic, education or cambridge english
                    item_category: (typeof updateQty_category !== "undefined") ? updateQty_category : "", // Subject
                    item_category2: (typeof updateQty_category2 !== "undefined") ? updateQty_category2 : "", // Learning Stage
                    item_category3: (typeof updateQty_category3 !== "undefined") ? updateQty_category3 : "", // Qualification
                    item_category4: (typeof updateQty_category4 !== "undefined") ? updateQty_category4 : "", // Format
                    item_category5: (typeof updateQty_category5 !== "undefined") ? updateQty_category5 : "", // Series Name
                    item_list_id: "", // The ID of the list in which the item was presented to the user. We may not be using this.
                    item_list_name: updateQty_list, // The name of the list in which the item was presented to the user. In this case Bag List
                    item_variant: updateQty_variant, // The item variant or unique code or description for additional item details/options.
                    location_id: "", // The physical location associated with the item (e.g. the physical store location) NA
                    price: parseFloat(updateQty_price), // The monetary price of the item, in units of the specified currency parameter.
                    quantity: updateQty_quantity // Item quantity.
                  }
                ]
              }
            },
          };
        } else {
          // GA3 Remove From Cart Using Dropdown
          tagManagerArgs_updateQty_GA3 = {
            gtmId: gtmId,
            dataLayer: {
              event: "removeFromCart", // name of an event. In this case, always stays as removeFromCart
              ecommerce: {
                // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                currencyCode: updateQty_currency, // the currency which is currently used by a visitor
                remove: {
                  // name of an action. In this case, always stays as remove
                  actionField: {
                    list: updateQty_list, // optional. name of a list from which the product was deleted from a cart
                  },
                  products: [
                    {
                      // list of products removed from a cart. can include multiple products.
                      name: updateQty_name, // name of a product that was removed from a cart
                      id: updateQty_id, // id of a product
                      price: updateQty_price, // price of a product
                      brand: updateQty_brand, // brand/vendor of a product
                      category: updateQty_category_old, // category of a product
                      variant: updateQty_variant, // product variant. If there are no variants, exclude this key from the dataLayer.push
                      quantity: updateQty_quantity, // Item quantity.
                    },
                  ],
                },
              },
            },
          };

          // GA4 Remove From Cart Using Dropdown
          tagManagerArgs_updateQty_GA4 = {
            gtmId: gtmId,
            dataLayer: {
              event: "remove_from_cart", // name of an event. In this case, always stays as remove_from_cart
              ecommerce: { // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                items: [ // The items for the event - this is an array
                  {
                    item_id: updateQty_id, // The ID of the item, in our case ISBN
                    item_name: updateQty_name, // The name of the item
                    affiliation: "Cambridge", // A product affiliation to designate a supplying company or brick and mortar store location. In our case, Cambridge
                    coupon: this.state.promoCodeConfirm ? this.state.promoCodeConfirm : this.props.data.discountCode, // The coupon name/code associated with the item.
                    currency: updateQty_currency, // Currency of the items associated with the event
                    discount: updateQty_discountedPrice ? (parseFloat(updateQty_price - updateQty_discountedPrice)) : 0.00, // The monetary discount value associated with the item.
                    index: updateQty_index, // The index/position of the item in a list.
                    item_brand: updateQty_brand, // The brand of the item. In our case academic, education or cambridge english
                    item_category: (typeof updateQty_category !== "undefined") ? updateQty_category : "", // Subject
                    item_category2: (typeof updateQty_category2 !== "undefined") ? updateQty_category2 : "", // Learning Stage
                    item_category3: (typeof updateQty_category3 !== "undefined") ? updateQty_category3 : "", // Qualification
                    item_category4: (typeof updateQty_category4 !== "undefined") ? updateQty_category4 : "", // Format
                    item_category5: (typeof updateQty_category5 !== "undefined") ? updateQty_category5 : "", // Series Name
                    item_list_id: "", // The ID of the list in which the item was presented to the user. We may not be using this.
                    item_list_name: updateQty_list, // The name of the list in which the item was presented to the user. In this case Bag List
                    item_variant: updateQty_variant, // The item variant or unique code or description for additional item details/options.
                    location_id: "", // The physical location associated with the item (e.g. the physical store location) NA
                    price: parseFloat(updateQty_price), // The monetary price of the item, in units of the specified currency parameter.
                    quantity: updateQty_quantity // Item quantity.
                  }
                ]
              }
            },
          };
        }

        // GA3 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_updateQty_GA3);
        // GA4 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_updateQty_GA4);
        break;
      case "removeFromCart":
        // ------------------- on delete item from bag ------------------- //

        const removeFromCart_list = this.props.data.currentPage;
        const removeFromCart_name = this.state.deleteTitle;
        const removeFromCart_id = this.state.deleteISBN;
        const removeFromCart_price = this.state.deletePrice;
        const removeFromCart_brand = this.state.deleteBrand;
        const removeFromCart_category_old = this.state.deleteCategoryOld;
        const removeFromCart_category = this.state.deleteCategory;
        const removeFromCart_category2 = this.state.deleteCategory2;
        const removeFromCart_category3 = this.state.deleteCategory3;
        const removeFromCart_category4 = this.state.deleteCategory4;
        const removeFromCart_category5 = this.state.deleteCategory5;
        const removeFromCart_variant = this.state.deleteType;
        const removeFromCart_quantity = this.state.deleteQty;
        const removeFromCart_currency = this.state.confirmCurrencyCode;
        const removeFromCart_discountedPrice = this.state.deleteDiscountedPrice;
        const removeFromCart_index = this.state.deleteIndex;
        let tagManagerArgs_removeFromCart_GA3 = "";
        let tagManagerArgs_removeFromCart_GA4 = "";

        // GA3 Remove From Cart Using Trash Can Button
        tagManagerArgs_removeFromCart_GA3 = {
          gtmId: gtmId,
          dataLayer: {
            event: "removeFromCart", // name of an event. In this case, always stays as removeFromCart
            ecommerce: {
              // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
              currencyCode: removeFromCart_currency, // the currency which is currently used by a visitor
              remove: {
                // name of an action. In this case, always stays as remove
                actionField: {
                  list: removeFromCart_list, // optional. name of a list from which the product was deleted from a cart
                },
                products: [
                  {
                    // list of products removed from a cart. can include multiple products.
                    name: removeFromCart_name, // name of a product that was removed from a cart
                    id: removeFromCart_id, // id of a product
                    price: removeFromCart_price, // price of a product
                    brand: removeFromCart_brand, // brand/vendor of a product
                    category: removeFromCart_category_old, // category of a product
                    variant: removeFromCart_variant, // product variant. If there are no variants, exclude this key from the dataLayer.push
                    quantity: removeFromCart_quantity, // Item quantity.
                  },
                ],
              },
            },
          },
        };

        // GA4 Remove From Cart Using Trash Can Button
        tagManagerArgs_removeFromCart_GA4 = {
          gtmId: gtmId,
          dataLayer: {
            event: "remove_from_cart", // name of an event. In this case, always stays as remove_from_cart
            ecommerce: { // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
              items: [ // The items for the event - this is an array
                {
                  item_id: removeFromCart_id, // The ID of the item, in our case ISBN
                  item_name: removeFromCart_name, // The name of the item
                  affiliation: "Cambridge", // A product affiliation to designate a supplying company or brick and mortar store location. In our case, Cambridge
                  coupon: this.state.promoCodeConfirm ? this.state.promoCodeConfirm : this.props.data.discountCode, // The coupon name/code associated with the item.
                  currency: removeFromCart_currency, // Currency of the items associated with the event
                  discount: removeFromCart_discountedPrice ? (parseFloat(removeFromCart_price - removeFromCart_discountedPrice)) : 0.00, // The monetary discount value associated with the item.
                  index: removeFromCart_index, // The index/position of the item in a list.
                  item_brand: removeFromCart_brand, // The brand of the item. In our case academic, education or cambridge english
                  item_category: (typeof removeFromCart_category !== "undefined") ? removeFromCart_category : "", // Subject
                  item_category2: (typeof removeFromCart_category2 !== "undefined") ? removeFromCart_category2 : "", // Learning Stage
                  item_category3: (typeof removeFromCart_category3 !== "undefined") ? removeFromCart_category3 : "", // Qualification
                  item_category4: (typeof removeFromCart_category4 !== "undefined") ? removeFromCart_category4 : "", // Format
                  item_category5: (typeof removeFromCart_category5 !== "undefined") ? removeFromCart_category5 : "", // Series Name
                  item_list_id: "", // The ID of the list in which the item was presented to the user. We may not be using this.
                  item_list_name: removeFromCart_list, // The name of the list in which the item was presented to the user. In this case Bag List
                  item_variant: removeFromCart_variant, // The item variant or unique code or description for additional item details/options.
                  location_id: "", // The physical location associated with the item (e.g. the physical store location) NA
                  price: parseFloat(removeFromCart_price), // The monetary price of the item, in units of the specified currency parameter.
                  quantity: removeFromCart_quantity // Item quantity.
                }
              ]
            }
          },
        };

        // GA3 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_removeFromCart_GA3);
        // GA4 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_removeFromCart_GA4);
        break;
      case "checkoutOptionStep1":
        // ------------------- Add Address on Your Details section ------------------- //
        let tagManagerArgs_checkoutOptionStep1_GA3 = "";
        let tagManagerArgs_checkoutOptionStep1_GA4 = "";

        // GA3 Add Shipping Info
        tagManagerArgs_checkoutOptionStep1_GA3 = {
          gtmId: gtmId,
          dataLayer: {
            event: "checkoutOption", // name of an event. In this case, always stays as checkoutOption
            ecommerce: {
              // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
              checkout_option: {
                // name of an action. In this case, always stays as checkout_option
                actionField: {
                  step: 1, // number of the checkout step in which a user chose an action for the delivery address - add, edit or delete
                  option: "address", // payment option that a visitor has chosen (add, edit or delete)
                },
              },
            },
          },
        };

        // GA4 Add Shipping Info

        let shipping_products = [];
        if(this.state.confirmAvailable || this.state.confirmPreorder || this.state.confirmPartial || this.state.confirmMarketRestricted || this.state.confirmUnavailable){
          shipping_products = [
            ...this.state.confirmAvailable,
            ...this.state.confirmPreorder,
            ...this.state.confirmPartial,
            ...this.state.confirmMarketRestricted,
            ...this.state.confirmUnavailable,
          ];
        }
        else{
          shipping_products = [...this.props.data.cart];
        }

        const shipping_items = shipping_products.map((item, index) => {
          return {
            item_id: item.isbn,                       // The ID of the item, in our case ISBN
            item_name: item.title,                    // The name of the item
            affiliation: "Cambridge", // A product affiliation to designate a supplying company or brick and mortar store location. In our case, Cambridge
            coupon: this.state.promoCodeConfirm ? this.state.promoCodeConfirm : this.props.data.discountCode,         // The coupon name/code associated with the item.
            currency: this.state.confirmCurrencyCode, // Currency of the items associated with the event
            discount: item.discountedPrice ? (parseFloat(item.price - item.discountedPrice)) : 0.00, // The monetary discount value associated with the item.
            index: index,                             // The index/position of the item in a list.
            item_brand: item.gtm.brand,               // The brand of the item. In our case academic, education or cambridge english
            item_category: (typeof item.subject !== "undefined") ? item.subject : "", // Subject
            item_category2: (typeof item.learningStage !== "undefined") ? item.learningStage : "", // Learning Stage
            item_category3: (typeof item.qualification !== "undefined") ? item.qualification : "", // Qualification
            item_category4: (typeof item.type !== "undefined") ? item.type : "", // Format
            item_category5: (typeof item.series !== "undefined") ? item.series : "", // Series Name
            item_list_id: "",                         // The ID of the list in which the item was presented to the user. We may not be using this.
            item_list_name: this.props.data.currentPage,   // The name of the list in which the item was presented to the user. In this case Bag List
            item_variant: item.gtm.variant,           // The item variant or unique code or description for additional item details/options.
            location_id: "",                          // The physical location associated with the item (e.g. the physical store location) NA
            price: parseFloat(item.price),                        // The monetary price of the item, in units of the specified currency parameter.
            quantity: item.quantity,                  // Item quantity.
          }
        });
        tagManagerArgs_checkoutOptionStep1_GA4 = {
          gtmId: gtmId,
          dataLayer: {
            event: "add_shipping_info", // name of an event. In this case, always stays as add_shipping_info
            ecommerce: { // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
              currency: this.state.confirmCurrencyCode, // Currency of the items associated with the event
              value: parseFloat(this.state.grandTotal), // The monetary value of the event
              coupon: this.state.promoCodeConfirm ? this.state.promoCodeConfirm : this.props.data.discountCode, // The coupon name/code associated with the item.
              shipping_tier: "",
              items: shipping_items, // list of products a user had in a cart before entering the checkout
            }
          }
        }

        this.setState({isAddAddress: false,});

        // GA3 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_checkoutOptionStep1_GA3);
        // GA4 Data Layer Push
        TagManager.dataLayer(tagManagerArgs_checkoutOptionStep1_GA4);
        break;
      case "checkout_continuePayment":
        // ------------------- on click Continue to Payment button ------------------- //

        let checkout_products_c = [];
        
        if(this.state.confirmAvailable || this.state.confirmPreorder || this.state.confirmPartial || this.state.confirmMarketRestricted || this.state.confirmUnavailable){
          checkout_products_c = [
            ...this.state.confirmAvailable,
            ...this.state.confirmPreorder,
            ...this.state.confirmPartial,
            ...this.state.confirmMarketRestricted,
            ...this.state.confirmUnavailable,
          ];
        }
        else{
          checkout_products_c = [...this.props.data.cart];
        }

        const continuePayment_currency = this.state.confirmCurrencyCode;
        const continuePaymentItems = checkout_products_c.map((item) => {
          return {
            name: item.title,
            id: item.isbn,
            price: item.discountedPrice && item.discountedPrice > 0 ? item.discountedPrice : item.price,
            brand: item.gtm.brand,
            category: item.gtm.category,
            variant: item.gtm.variant,
            quantity: item.quantity,
          };
        });
        this.setState(
          {
            checkout_products: continuePaymentItems,
          },
          () => {
            const tagManagerArgs_checkout_continuePayment = {
              gtmId: gtmId,
              dataLayer: {
                event: "checkout", // name of an event. In this case, always stays as checkout
                ecommerce: {
                  // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                  currencyCode: continuePayment_currency,
                  checkout: {
                    // name of an action. In this case, always stays as checkout
                    actionField: {
                      step: 2, // number of the checkout step that a user has entered
                    },
                    products: this.state.checkout_products, // list of products a user had in a cart before payment
                  },
                },
              },
            };
            const tagManagerArgs_checkout_continuePayment_step3 = {
              gtmId: gtmId,
              dataLayer: {
                event: "checkout", // name of an event. In this case, always stays as checkout
                ecommerce: {
                  // ecommerce object. This is the essential part of tracking. New EE data must always be pushed to this object
                  currencyCode: continuePayment_currency,
                  checkout: {
                    // name of an action. In this case, always stays as checkout
                    actionField: {
                      step: 3, // number of the checkout step that a user has entered
                    },
                  },
                },
              },
            };

            TagManager.dataLayer(tagManagerArgs_checkout_continuePayment);
            TagManager.dataLayer(tagManagerArgs_checkout_continuePayment_step3);
          }
        );
        // );
        break;
    }
  };
  pageOnKeyUp = (e) => {
    if (e.which == 27) {
      // if ESC KEY was pressed
      this.setState({
        isChangeCountryFormModalOpen: "",
        isChangeCountryModalOpen: "",
        isEditAddressModalOpen: "",
        isDeleteAddressModalOpen: "",
        isRemoveModalOpen: "",
        isBagRemoveModalOpen: "",
        isRedirectGuestModalShow: "",
      });
    }
  };
  billingRadioChange = (e) => {
    this.clearAddAddressFields();
    if (e == "sameAsDelivery") {
      if (!this.state.isSameAsDelivery) {
        // If delivery and billing address is different, call API
        this.setState(
          {
            ...this.state,
            defaultBillingAddressID: this.state.chosenDeliveryAddress.id,
            chosenBillingAddress: {
              id: this.state.chosenDeliveryAddress.id,
            },
            isSameAsDelivery: true,
            isBillingRadioSameClicked: true,
            isBillingRadioDifferentClicked: false,
          },
          () => {
            this.changeBillingAddressAPI();
            this.isContinuePaymentValidHandler();
          }
        );
      } else {
        this.setState({
          isBillingRadioSameClicked: true,
          isBillingRadioDifferentClicked: false,
          isBillingOptionsOpen: false,
        },()=>{
          this.isContinuePaymentValidHandler();
        });
      }
    } else {
      // if otherBillingAddress
      this.setState({
        isBillingRadioSameClicked: false,
        isBillingRadioDifferentClicked: true,
        isBillingOptionsOpen: true,
      },()=>{
        this.isContinuePaymentValidHandler();
      });
      if (this.state.confirmAddressSummary.length == 1 && this.state.isSameAsDelivery) {
        this.showAddressModalHandler("addBillingAddress");
      }
      if(this.state.chosenBillingAddress.id){
        // If user has a selected billing address
      }
      else{
        this.setState({
          showAddBilAddressForm: true
        });
      }
    }
  };
  toggleBillingSection = () => {
    this.closeAddressModalHandler();
    if (this.state.isSameAsDelivery && this.state.isBillingOptionsOpen) {
      this.setState({
        isBillingRadioSameClicked: true,
        isBillingRadioDifferentClicked: false,
        isBillingOptionsOpen: !this.state.isBillingOptionsOpen,
      },()=>{
        this.isContinuePaymentValidHandler();
      });
    }
    else{
      this.setState({
        isBillingOptionsOpen: !this.state.isBillingOptionsOpen,
      },()=>{
        this.isContinuePaymentValidHandler();
      });
    }
    this.setState({
      makeAsDefaultAddress: false,
    });
  };
  onMakeAsDefaultChange = (e) =>{
    this.setState({
      makeAsDefaultAddress: e.target.checked,
    });
  }
  loadAddresses = () => {
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    //        Addresses API        //
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    let onLoadDeliveryAddressID = "";
    let onLoadDeliveryAddressFirstName = "";
    let onLoadDeliveryAddressLastName = "";
    let onLoadDeliveryAddressLine1 = "";
    let onLoadDeliveryAddressLine2 = "";
    let onLoadDeliveryAddressCity = "";
    let onLoadDeliveryAddressStateZoneCode = "";
    let onLoadDeliveryAddressStateZoneName = "";
    let onLoadDeliveryAddressStateName = "";
    let onLoadDeliveryAddressPostCode = "";
    let onLoadDeliveryAddressCountryCode = "";
    let onLoadDeliveryAddressCountryName = "";
    let onLoadDeliveryAddressPhoneNumber = "";

    let onLoadBillingAddressID = "";
    let onLoadBillingAddressFirstName = "";
    let onLoadBillingAddressLastName = "";
    let onLoadBillingAddressLine1 = "";
    let onLoadBillingAddressLine2 = "";
    let onLoadBillingAddressCity = "";
    let onLoadBillingAddressStateZoneCode = "";
    let onLoadBillingAddressStateZoneName = "";
    let onLoadBillingAddressStateName = "";
    let onLoadBillingAddressPostCode = "";
    let onLoadBillingAddressCountryCode = "";
    let onLoadBillingAddressCountryName = "";
    let onLoadBillingAddressPhoneNumber = "";

    this.checkoutGTM();

    if (this.state.confirmAddressSummary && this.state.confirmAddressSummary.length) {
      this.state.confirmAddressSummary.map((item, index) => {
        if (item.selectedShippingAddress) {
          onLoadDeliveryAddressID = item.id;
          onLoadDeliveryAddressFirstName = item.firstName;
          onLoadDeliveryAddressLastName = item.lastName;
          onLoadDeliveryAddressLine1 = item.streetAddress;
          onLoadDeliveryAddressLine2 = item.streetAddress1;
          onLoadDeliveryAddressCity = item.city;
          onLoadDeliveryAddressStateZoneCode = 0;
          onLoadDeliveryAddressStateZoneName = item.state;
          onLoadDeliveryAddressStateName = item.state;
          onLoadDeliveryAddressPostCode = item.postcode;
          onLoadDeliveryAddressCountryCode = item.countryId;
          onLoadDeliveryAddressCountryName = item.countryName;
          onLoadDeliveryAddressPhoneNumber = item.telephoneNumber;
        }
      });
      this.state.confirmAddressSummary.map((item, index) => {
        if (item.selectedBillingAddress) {
          onLoadBillingAddressID = item.id;
          onLoadBillingAddressFirstName = item.firstName;
          onLoadBillingAddressLastName = item.lastName;
          onLoadBillingAddressLine1 = item.streetAddress;
          onLoadBillingAddressLine2 = item.streetAddress1;
          onLoadBillingAddressCity = item.city;
          onLoadBillingAddressStateZoneCode = 0;
          onLoadBillingAddressStateZoneName = item.state;
          onLoadBillingAddressStateName = item.state;
          onLoadBillingAddressPostCode = item.postcode;
          onLoadBillingAddressCountryCode = item.countryId;
          onLoadBillingAddressCountryName = item.countryName;
          onLoadBillingAddressPhoneNumber = item.telephoneNumber;
        }
      });
      this.setState({
        defaultDeliveryAddressID: onLoadDeliveryAddressID,
        chosenDeliveryAddress: {
          id: onLoadDeliveryAddressID,
          firstName: onLoadDeliveryAddressFirstName,
          lastName: onLoadDeliveryAddressLastName,
          addressLine1: onLoadDeliveryAddressLine1,
          addressLine2: onLoadDeliveryAddressLine2,
          city: onLoadDeliveryAddressCity,
          stateZoneCode: onLoadDeliveryAddressStateZoneCode,
          stateZoneName: onLoadDeliveryAddressStateZoneName,
          stateName: onLoadDeliveryAddressStateName,
          postCode: onLoadDeliveryAddressPostCode,
          countryCode: onLoadDeliveryAddressCountryCode,
          countryName: onLoadDeliveryAddressCountryName,
          phoneNumber: onLoadDeliveryAddressPhoneNumber,
        },
        onLoadBillingAddress: {
          id: onLoadBillingAddressID,
          firstName: onLoadBillingAddressFirstName,
          lastName: onLoadBillingAddressLastName,
          addressLine1: onLoadBillingAddressLine1,
          addressLine2: onLoadBillingAddressLine2,
          city: onLoadBillingAddressCity,
          stateZoneCode: onLoadBillingAddressStateZoneCode,
          stateZoneName: onLoadBillingAddressStateZoneName,
          stateName: onLoadBillingAddressStateName,
          postCode: onLoadBillingAddressPostCode,
          countryCode: onLoadBillingAddressCountryCode,
          countryName: onLoadBillingAddressCountryName,
          phoneNumber: onLoadBillingAddressPhoneNumber,
        },
        chosenBillingAddress: {
          id: onLoadBillingAddressID,
          firstName: onLoadBillingAddressFirstName,
          lastName: onLoadBillingAddressLastName,
          addressLine1: onLoadBillingAddressLine1,
          addressLine2: onLoadBillingAddressLine2,
          city: onLoadBillingAddressCity,
          stateZoneCode: onLoadBillingAddressStateZoneCode,
          stateZoneName: onLoadBillingAddressStateZoneName,
          stateName: onLoadBillingAddressStateName,
          postCode: onLoadBillingAddressPostCode,
          countryCode: onLoadBillingAddressCountryCode,
          countryName: onLoadBillingAddressCountryName,
          phoneNumber: onLoadBillingAddressPhoneNumber,
        },
        confirmApiLoader: false,
        bagLoader: false,
        onLoadCountryId: onLoadDeliveryAddressCountryCode,
      });
      if (onLoadDeliveryAddressID === onLoadBillingAddressID) {
        this.setState(
          {
            initialAddress: onLoadDeliveryAddressID,
            initialBilling: onLoadBillingAddressID,
            isSameAsDelivery: true,
            isBillingRadioSameClicked: true,
            isBillingRadioDifferentClicked: false,
            isBillingOptionsOpen: false,
          },
          () => {
            this.isContinuePaymentValidHandler();
            this.isAuRegion();
          }
        );
      } else {
        this.setState(
          {
            initialAddress: onLoadDeliveryAddressID,
            initialBilling: onLoadBillingAddressID,
          },
          () => {
            if((onLoadDeliveryAddressID && onLoadBillingAddressID) && (onLoadDeliveryAddressID != onLoadBillingAddressID)){
              // If delivery address is different from billing address
              this.setState({
                isSameAsDelivery: false,
                isBillingRadioSameClicked: false,
                isBillingRadioDifferentClicked: true,
              },()=>{
                this.isContinuePaymentValidHandler();
              });
            }
            else{
              this.setState({
                isSameAsDelivery: false,
                isBillingRadioSameClicked: false,
                isBillingRadioDifferentClicked: false,
              },()=>{
                this.isContinuePaymentValidHandler();
              });
            }
            this.isAuRegion();
          }
        );
      }
    }
  }
  loadBagApi = (source) => {
    this.clearOrderDetails();

    // Reload Bag API if 
    // user refreshes order-details page, or
    // user didn't come from Bag page (e.g., sign in page), or 
    // user deleted all addresses
    if((!this.props.data.cameFromBagPage) || (source=="deleteApi")){
      // triggers begin_checkout event if guest  
      this.props.getBagAPI();
    }
    this.setState({checkout_gtm_fireonce: true});
    this.isContinuePaymentValidHandler();
  }
  setOrderItems = (response, availableCount, unavailableCount, preorderCount, partialCount, source) => {
    // If API didn't return any addresses,
    // set cart items.
    // If order-details products exist, load order-details API items
    // If order-details products doesn't exist, load bag API items instead
    this.setState(
      {
        OrderSummary: response.data.OrderSummary,
        confirmAddressSummary: response.data.addressSummary,
        confirmShippingSummary: response.data.ShippingSummary,
        confirmAvailable: response.data.availableOrder,
        confirmUnavailable: response.data.unavailable,
        confirmUnavailableOnly: response.data.unavailable,
        confirmPreorder: response.data.preOrder,
        confirmMarketRestricted: response.data.marketRestricted,
        confirmPartial: response.data.partial,
        isConfirmApiLoaded: response.data.availableOrder,
        showAddDelAddressForm: false,
        showAddBilAddressForm: false,
        isBagUpdated: false,
        confirmApiLoader: false,
        bagLoader: false,
        confirmAPIErrors: "",
        confirmAPIErrorMessage: "",
        confirmAPIErrorHTML: "",
        promoInput: "",
        orderDetailsHasValue: response.data.addressSummary,
        hidePromoFieldOrderDetails: response.data.hidePromoField,
      },
      () => {
        let tempItemCount = 0;
        if (this.state.confirmAvailable) {
          this.state.confirmAvailable.forEach((item) => {
            tempItemCount = tempItemCount + parseInt(item.quantity);
          });
        }

        if (this.state.confirmUnavailable) {
          this.state.confirmUnavailable.forEach((item) => {
            tempItemCount = tempItemCount + parseInt(item.quantity);
          });
        }
        if (this.state.confirmPreorder) {
          this.state.confirmPreorder.forEach((item) => {
            tempItemCount = tempItemCount + parseInt(item.quantity);
          });
        }
        if (this.state.confirmMarketRestricted) {
          this.state.confirmMarketRestricted.forEach((item) => {
            tempItemCount = tempItemCount + parseInt(item.quantity);
          });
        }
        if (this.state.confirmPartial) {
          this.state.confirmPartial.forEach((item) => {
            tempItemCount = tempItemCount + parseInt(item.quantity);
          });
        }
        if (tempItemCount == 0) {
          this.props.confirmItemsEmpty();
        }
        if (this.state.confirmUnavailable && this.state.confirmMarketRestricted) {
          // If order-details products is not empty
          this.setState(
            {
              confirmUnavailable: [...this.state.confirmUnavailable, ...this.state.confirmMarketRestricted],
              confirmPreorderPartial: [...this.state.confirmPartial, ...this.state.confirmPreorder],
              confirmItemCount:
                this.state.confirmUnavailable.length +
                this.state.confirmMarketRestricted.length +
                this.state.confirmPreorder.length +
                this.state.confirmPartial.length +
                this.state.confirmAvailable.length,
              totalItemCount: tempItemCount,
            },
            () => {
              // ---------------------- Preorder ----------------------
              if (this.state.confirmAvailable) {
                availableCount = this.state.confirmAvailable.length;
              }
              if (this.state.confirmUnavailable) {
                unavailableCount = this.state.confirmUnavailable.length;
              }
              if (this.state.confirmPreorderPartial) {
                preorderCount = this.state.confirmPreorderPartial.length;
              }

              // Generate preview of bag items
              this.showBagPreview(availableCount, unavailableCount, preorderCount);

              if (this.state.OrderSummary && this.state.OrderSummary.length) {
                this.state.OrderSummary.map((orderSummary) => {
                  this.setState(
                    {
                      confirmCurrency: orderSummary.currencyCodeSymbol,
                      confirmCurrencyCode: orderSummary.currencyCode,
                      promoCodeConfirm: orderSummary.promoCodeValue,
                      promoCodeConfirmInput: orderSummary.promoCode,
                      promoCodeStatus: orderSummary.promoClassName,
                      promoCodeLabel: orderSummary.promoLabelText,
                      promoClassName: orderSummary.promoClassName,
                      deliveryLabel: orderSummary.deliveryLabel,
                      totalLabel: orderSummary.totalLabel,
                      taxLabel: orderSummary.taxLabel.toLowerCase() == "gst included" ? "GST" : orderSummary.taxLabel,
                      shippingFee: orderSummary.shippingFee,
                      shippingSubTotal: orderSummary.subTotal,
                      shippingTotal: orderSummary.total,
                      orderDiscountTotal: orderSummary.orderDiscountTotals,
                      grandTotal: orderSummary.total,
                      shippingPreOrderTotal: orderSummary.preOrderTotal,
                      chargeNow: orderSummary.chargeNow,
                      shippingTaxFee: orderSummary.taxFee,
                      availableCount: availableCount,
                      unavailableCount: unavailableCount,
                      preorderCount: preorderCount,
                      partialCount: partialCount,
                      promoCodeMessage: true,
                    },
                    () => {
                    }
                  );
                    
                  var isNewCodeValidButInapplicable = orderSummary.promoLabelText=="doesn't apply to products in your bag."; // If inputted code is valid but inapplicable
                  var isNewCodeNotExisting = orderSummary.promoCode != orderSummary.promoCodeValue; // If inputted promo code has been applied, it means the promo code exists/valid even if it's inapplicable
                  var isNewCodeError = orderSummary.promoClassName != "success"; // Inapplicable valid promo code will still return as error promo code
                  if(isNewCodeNotExisting && isNewCodeError && (this.state.prevPromoValidButInapplicable)){
                    // If user entered a new error promo code, and the previous promo code is valid but inapplicaple to bag, retain previous promo message
                    
                    // Hide new promo error message after 3 seconds
                    setTimeout(
                      () =>
                        this.setState({
                          promoCodeMessage: false,
                          promoCodeInputEntered: false,
                          prevPromoValidButInapplicable: true,
                        },()=>{
                          // After showing 3 seconds error message, show the previous inapplicable persistent error msg
                          this.setState({
                            promoCodeMessage: true,
                            promoCodeInputEntered: true,
                            promoCodeConfirmInput: this.state.promoCodeConfirm,
                            promoCodeLabel: "doesn't apply to products in your bag.",
                          })
                        }),
                      3000
                    );
                  }
                  else{
                    if(isNewCodeValidButInapplicable){
                      // Don't hide promo error message if code is valid but doesn't apply to products in the bag
                      this.setState({
                        promoCodeMessage: true,
                        promoCodeInputEntered: true,
                        prevPromoValidButInapplicable: isNewCodeValidButInapplicable,
                      })
                    }
                    else{
                      // Hide promo error message after 3 seconds
                      setTimeout(
                        () =>
                          this.setState({
                            promoCodeMessage: false,
                            promoCodeInputEntered: false,
                            prevPromoValidButInapplicable: isNewCodeValidButInapplicable,
                          }),
                        3000
                      );
                    }
                  }
                });
              }

              // Load addressSummary from API
              this.loadAddresses();

              if (this.state.confirmAddressSummary.length == 1) {
                this.setState({showAddBilAddressForm: true});
              }
            }
          );
        } else {
          // Remove billingAddressId cookie if order-details is blank
          Cookies.remove("billingAddressId");
          
          // If order-details products is empty, or if user deleted all address, load Bag API
          this.loadBagApi(source);

          // Refresh AU transaction fee notice banner
          this.isAuRegion();
        }
      }
    );
  }
  checkoutGTM = () => {
    if(this.state.isAddAddress) {
      this.triggerGTM("checkoutOptionStep1");
    }
  }
  clearOrderDetails = () => {
    this.setState({
      confirmApiLoader: false,
      bagLoader: false,
      isBagUpdated: false,
      confirmCurrency: "",
      promoCodeConfirm: "",
      promoCodeConfirmInput: "",
      promoCodeStatus: "",
      promoCodeLabel: "",
      promoClassName: "",
      deliveryLabel: "",
      totalLabel: "",
      taxLabel: "",
      shippingFee: "",
      shippingSubTotal: "",
      shippingTotal: "",
      orderDiscountTotal: "",
      grandTotal: "",
      shippingPreOrderTotal: "",
      shippingTaxFee: "",
      availableCount: "",
      unavailableCount: "",
      preorderCount: "",
      partialCount: "",
      isBillingOptionsOpen: false,
      isSameAsDelivery: false,
      isBillingRadioSameClicked: false,
      isBillingRadioDifferentClicked: false,
    });
  }
  render() {
    const Option = (props) => {
      if (props.value) {
        let countryCode = props.value.isoCode2;
        let nonDisplayCountryExists = this.state.lrcCountries.find((el) => el.isoCode2 === countryCode);

        if (nonDisplayCountryExists) {
          return (
            <div style={{display: "none"}}>
              <components.Option {...props} />
            </div>
          );
        } else {
          return (
            <div style={{}}>
              <components.Option {...props} />
            </div>
          );
        }
      } else return null;
    };

    return (
      <div onKeyUp={(e) => this.pageOnKeyUp(e)}>
        <Header
          page="checkout"
          headerTitle={this.props.headerTitle}
          customerIsGuest={this.props.data.customerIsGuest}
          isUserRegistered={this.props.data.isUserRegistered}
          path={this.props.data.continueShoppingUrl}
          customerId={Cookies.get("KK_CUSTOMER_ID")}
          customerEmail={Cookies.get("kkUserEmail")}
          signInLink={this.props.data.signInLink}
          signinAndCheckoutLink={this.props.data.signinAndCheckoutLink}
          confirmRedirect={
            this.state.confirmAddressSummary && this.state.confirmAddressSummary.length ? (e) => this.confirmRedirect(e, this.props.data.signInLink) : () => {}
          }
          isGuestRegisterSuccess={this.state.isGuestRegisterSuccess}
          customerIsLoggedIn={this.props.data.customerIsLoggedIn}
        />
        <GlobalStyle.BodyMainStyle className={this.state.checkoutSummaryFixed}>
          {this.props.data.bagLoader || this.props.data.profileLoader || this.state.bagLoader || this.state.confirmApiLoader ? <Loader /> : ""}
          {/* <Loader /> */}
          <h2 className="section-title">Main Content</h2>
          <div className="section-main">
            <div className="container main-container" style={{minHeight: "calc(100vh - 175px)"}}>
              {this.state.confirmAPIErrors ? (
                <div className="row">
                  <div className="col-12 ">
                    {this.state.confirmAPIErrorCode == "500" ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.confirmAPIErrorHTML,
                        }}
                      />
                    ) : (
                      <CheckoutPageError
                        pageErrorCode={this.state.confirmAPIErrorCode}
                        pageErrorMessage={this.state.confirmAPIErrorMessage}
                        refreshPage={this.props.refreshPage}
                      />
                    )}
                  </div>
                </div>
              ) : this.state.orderDetailsError ? (
                <CheckoutPageError pageErrorCode="" pageErrorMessage="" refreshPage={this.props.refreshPage} checkoutPage="orderDetails" />
              ) : (
                <div className="row" style={{minHeight: "calc(100vh - 175px)"}}>
                  <div className="col-12 col-md-7 col-lg-8">
                    <div className="section-main-left">
                      <MobileNav
                        scrollToBag={this.scrollToBag}
                        scrollToDetails={this.scrollToDetails}
                        scrollToPayment={this.scrollToPayment}
                        className={this.state.mobileNavFixed}
                      />
                      <CheckoutSummary
                        data={this.state}
                        bagDiscountCode={this.props.data.discountCode}
                        isNewPromoInput={this.state.promoCodeConfirmInput == this.state.promoCodeConfirm}
                        promoCodeInputFocus={this.promoCodeInputFocusHandler}
                        promoCodeInputBlur={this.promoCodeInputBlurHandler}
                        isPromoCodeInputFocus={this.state.promoCodeInputFocus}
                        promoCodeConfirm={this.state.promoCodeConfirm}
                        promoCodeConfirmInput={this.state.promoCodeConfirmInput}
                        promoCodeMessage={this.state.promoCodeMessage}
                        promoCodeLabel={this.state.promoCodeLabel}
                        promoClassName={this.state.promoClassName}
                        currency={this.state.confirmCurrency || this.props.data.currency}
                        orderDiscountTotal={this.state.orderDiscountTotal}
                        subTotal={
                          this.state.shippingSubTotal
                            ? this.state.confirmCurrency + "" + this.state.shippingSubTotal
                            : this.props.data.orderSummaryTotal
                            ? this.state.confirmCurrency +
                              "" +
                              (this.props.data.discountCode == "ALERTSDISCOUNT"
                                ? (Math.round(parseFloat(this.props.data.orderSummaryTotal.toString().replace(/,/g, "")) * (1 - 0.2) * 100) / 100).toFixed(2)
                                : this.props.data.orderSummaryTotal)
                            : "-"
                        }
                        total={
                          this.state.grandTotal
                            ? this.state.confirmCurrency + "" + this.state.grandTotal
                            : this.props.data.orderSummaryTotal
                            ? this.state.confirmCurrency +
                              "" +
                              (this.props.data.discountCode == "ALERTSDISCOUNT"
                                ? (Math.round(parseFloat(this.props.data.orderSummaryTotal.toString().replace(/,/g, "")) * (1 - 0.2) * 100) / 100).toFixed(2)
                                : this.props.data.orderSummaryTotal)
                            : "-"
                        }
                        vat={
                          this.state.shippingTaxFee
                            ? "Included " + (this.state.taxLabel || "VAT") + " of " + this.state.confirmCurrency + "" + this.state.shippingTaxFee
                            : ""
                        }
                        deliveryLabel={this.state.deliveryLabel}
                        totalLabel={this.state.totalLabel}
                        preorderTotal={this.state.shippingPreOrderTotal}
                        chargeNow={this.state.chargeNow}
                        shippingPrice={this.state.shippingFee ? this.state.confirmCurrency + "" + this.state.shippingFee : ""}
                        updatePromoInput={(event) => this.updatePromoInputHandler(event)}
                        applyPromo={(event) => this.applyPromoHandler(event)}
                        continueToPayment={() => this.continueToPaymentHandler()}
                        isContinuePaymentValid={this.state.isContinuePaymentValid}
                        promoInputValue={this.state.promoInput}
                        type="mobile"
                        className="mobile-checkout-summary"
                        confirmPreorder={this.state.confirmPreorder ? this.state.confirmPreorder.length : 0}
                        confirmAvailable={this.state.confirmAvailable ? this.state.confirmAvailable.length : 0}
                        unavailableCount={this.state.unavailableCount}
                        availableCount={this.state.availableCount}
                        preorderCount={this.state.preorderCount}
                        partialCount={this.state.partialCount}
                        promoCodeInputEntered={this.state.promoCodeInputEntered}
                        addressExists={this.state.confirmAddressSummary}
                        hidePromoFieldBag={this.props.data.hidePromoFieldBag}
                        hidePromoFieldOrderDetails={this.state.hidePromoFieldOrderDetails}
                      />
                      <GlobalStyle.DesktopContinueShopping>
                        <ContinueShopping path={this.props.data.continueShoppingUrl} />
                      </GlobalStyle.DesktopContinueShopping>
                      <ApiError error={this.state.addAddressAPIErrors || this.props.data.bagAPIErrors} />

                      {this.state.auTransactionFeeBanner ? (
                        <Banner
                          title="Please note"
                          body="Your transactions may incur a foreign transaction fee, not included in the final price listed but will appear on your credit card statement. This charge is made by your credit card provider, not by Cambridge University Press."
                          className="info"
                        />
                      ) : (
                        ""
                      )}

                      <ConfirmBag
                        data={this.state}
                        isRemoveModalOpen={this.showConfirmModalHandler}
                        isBagRemoveModalOpen={this.showBagConfirmModalHandler}
                        app={this.props}
                        itemCount={this.state.totalItemCount || this.props.itemCount}
                        accordionBagRef={this.accordionBagRef}
                        cart={this.props.data.cart}
                        currency={this.state.confirmCurrency || this.props.bagCurrency}
                        unavailablePreview={this.state.unavailablePreview}
                        preorderPreview={this.state.preorderPreview}
                        availablePreview={this.state.availablePreview}
                        totalConfirmPreview={this.state.totalConfirmPreview}
                        changed={(event) => this.bagTabToggleHandler(event)}
                        isConfirmApiLoaded={this.state.isConfirmApiLoaded}
                        discountCode={this.state.promoCodeConfirm ? this.state.promoCodeConfirm : this.props.data.discountCode}
                        discountLess={0.2}
                        changeQuantityHandler={this.changeQuantityHandler}
                      />
                      <ConfirmEmail
                        data={this.state}
                        kkUserEmail={Cookies.get("kkUserEmail")}
                        submitGuestEmail={this.state.submitGuestEmail}
                        isGuestRegisterSuccess={this.state.isGuestRegisterSuccess}
                        appProp={this.props}
                        accordionDetailsRef={this.accordionDetailsRef}
                        guestEmailChangedHandler={(event) => this.addModalChangedHandler(event, "guestEmail")}
                        guestEmailBlurHandler={(event) => this.inputBlurHandler(event, "guestEmail")}
                        signInLink={this.props.data.signInLink}
                        signinAndCheckoutLink={this.props.data.signinAndCheckoutLink}
                        confirmRedirect={
                          this.state.confirmAddressSummary && this.state.confirmAddressSummary.length
                            ? (e) => this.confirmRedirect(e, this.props.data.signInLink)
                            : () => {}
                        }
                        guestEmailRef={this.guestEmailRef}
                        onKeyPress={(event) => this.keypressHandler(event)}
                        customerIsGuest={this.props.data.customerIsGuest}
                        isUserRegistered={this.props.data.isUserRegistered}
                        customerIsLoggedIn={this.props.data.customerIsLoggedIn}
                      />

                      <ConfirmDelivery
                        isUserRegistered={this.props.isUserRegistered}
                        isGuestRegisterSuccess={this.state.isGuestRegisterSuccess}
                        data={this.state}
                        appProp={this.props}
                        profileEmail={Cookies.get("kkUserEmail")}
                        customerIsGuest={this.props.data.customerIsGuest}
                        defaultDeliveryAddressID={this.props.data.defaultDeliveryAddressID}
                        countryInputHandler={this.countryInputHandler}
                        countryFocusHandler={this.countryFocusHandler}
                        countryBlurHandler={this.countryBlurHandler}
                        countryComponents={{Option}}
                        stateZoneFocusHandler={this.stateZoneFocusHandler}
                        stateZoneBlurHandler={this.stateZoneBlurHandler}
                        updateSelectedDeliveryAddress={this.updateSelectedDeliveryAddress}
                        changed={(event) => this.deliveryTabToggleHandler(event)}
                        showEditAddressHandler={this.showEditAddressHandler}
                        isDeleteAddressModalOpenHandler={this.isDeleteAddressModalOpenHandler}
                        handleKeyDown={this.handleKeyDown}
                        closeAddressModalHandler={this.closeAddressModalHandler}
                        addressFirstNameRef={(input) => {
                          this.addressFirstNameRef = input;
                        }}
                        addModalChangedHandler={this.addModalChangedHandler}
                        countryOptionsHandler={this.countryOptionsHandler()}
                        addAddressLineModalHandler={this.addAddressLineModalHandler}
                        addAddressModalHandler={this.addAddressModalHandler}
                        showAddressModalHandler={this.showAddressModalHandler}
                        chosenCountryCode={this.state.chosenDeliveryAddress.countryCode}
                        changeCountryPrompt={this.changeCountryPrompt}
                        onMakeAsDefaultChange={(event) => this.onMakeAsDefaultChange(event)}
                      />

                      <Accordion
                        classes="billing-tab"
                        tabName=""
                        changed={this.toggleBillingSection}
                        toggle={this.toggleBillingSection}
                        accordionId="accordionBilling"
                        userAddresses={this.props.data.confirmAddressSummary}
                        profileEmail={Cookies.get("kkUserEmail")}
                        customerIsGuest={this.props.data.customerIsGuest}
                        isSameAsDelivery={this.state.isSameAsDelivery}
                        chosenBillingAddressID={this.state.chosenBillingAddress.id}
                        chosenBillingAddressFirstName={this.state.chosenBillingAddress.firstName}
                        chosenBillingAddressLastName={this.state.chosenBillingAddress.lastName}
                        chosenBillingAddressLine1={this.state.chosenBillingAddress.addressLine1}
                        chosenBillingAddressLine2={this.state.chosenBillingAddress.addressLine2}
                        chosenBillingAddressCity={this.state.chosenBillingAddress.city}
                        chosenBillingAddressStateZone={this.state.chosenBillingAddress.stateZoneName}
                        chosenBillingAddressState={this.state.chosenBillingAddress.stateName}
                        chosenBillingAddressPostCode={this.state.chosenBillingAddress.postCode}
                        chosenBillingAddressCountryCode={this.state.chosenBillingAddress.countryCode}
                        chosenBillingAddressCountryName={this.state.chosenBillingAddress.countryName}
                        chosenBillingAddressPhoneNumber={this.state.chosenBillingAddress.phoneNumber}
                        data={this.state}
                        billingRadioChange={(e)=>this.billingRadioChange(e.target.value)}>
                        {this.state.confirmApiLoader || this.state.bagLoader ? '' : 
                        <div>
                        {
                        this.state.isBillingOptionsOpen ?
                          <BillingOptions 
                            data={this.state} 
                            billingRadioChange={(e)=>this.billingRadioChange(e.target.value)} 
                            closeAddressModalHandler={(e)=>{this.closeAddressModalHandler(e)}}
                          />
                        : this.state.chosenBillingAddress.id == "" ?
                          <BillingOptions 
                            data={this.state} 
                            billingRadioChange={(e)=>this.billingRadioChange(e.target.value)} 
                            closeAddressModalHandler={(e)=>{this.closeAddressModalHandler(e)}}
                          />
                        : this.state.isSameAsDelivery ?
                          <BillingOptions 
                            data={this.state} 
                            billingRadioChange={(e)=>this.billingRadioChange(e.target.value)} 
                            closeAddressModalHandler={(e)=>{this.closeAddressModalHandler(e)}}
                          />
                        : ''
                        }
                        {
                          this.state.isBillingOptionsOpen && this.state.chosenBillingAddressID != "" && this.state.confirmAddressSummary && this.state.confirmAddressSummary.length > 1
                            ? this.state.confirmAddressSummary.filter(item => item.id != this.state.chosenDeliveryAddress.id).map((item, index) => (
                                <Address
                                  key={item.id}
                                  id={item.id}
                                  firstName={item.firstName}
                                  lastName={item.lastName}
                                  addressLine1={item.streetAddress}
                                  addressLine2={item.streetAddres1}
                                  city={item.city}
                                  postCode={item.postcode}
                                  state={item.state}
                                  country={item.countryName}
                                  phoneNumber={item.telephoneNumber}
                                  addressType="billing"
                                  isPrimary={item.isPrimary}
                                  selectedAddress={item.selectedBillingAddress}
                                  updateSelectedAddress={(event) =>
                                    this.updateSelectedBillingAddress(
                                      event,
                                      item.id,
                                      item.firstName,
                                      item.lastName,
                                      item.streetAddress,
                                      item.streetAddres1,
                                      item.city,
                                      0,
                                      item.state,
                                      item.state,
                                      item.postcode,
                                      item.countryId,
                                      item.countryName,
                                      item.telephoneNumber
                                    )
                                  }
                                  isDeleteAddressModalOpen={(event) => this.isDeleteAddressModalOpenHandler(item.id)}
                                  editAddressToggle={() =>
                                    this.showEditAddressHandler(
                                      item.id,
                                      item.customerId,
                                      item.countryId,
                                      item.countryName,
                                      item.firstName,
                                      item.lastName,
                                      item.streetAddress,
                                      item.streetAddres1,
                                      item.city,
                                      0,
                                      item.state,
                                      item.state,
                                      item.postcode,
                                      item.telephoneNumber,
                                      item.emailAddr,
                                      "billing"
                                    )
                                  }
                                  showDeliveryEditAddressFormID={this.state.showDeliveryEditAddressFormID}
                                  showBillingEditAddressFormID={this.state.showBillingEditAddressFormID}>
                                  {this.state.showEditAddressForm ? (
                                    <AddressForm
                                      title="Edit address"
                                      process="edit"
                                      close={(event) => this.closeAddressModalHandler(event)}
                                      data={this.state}
                                      myRef={(input) => {
                                        this.addressFirstNameRef = input;
                                      }}
                                      onCountryFocus={(event) => this.countryFocusHandler(event)}
                                      onCountryBlur={(event) => this.countryBlurHandler(event)}
                                      onCountryChange={(event) => this.addModalChangedHandler(event, "addressRegion")}
                                      countryOptions={this.countryOptionsHandler()}
                                      countryComponents={{Option}}
                                      onCountryInputChange={this.countryInputHandler}
                                      onFirstNameChange={(event) => this.addModalChangedHandler(event, "addressFirstName")}
                                      onLastNameChange={(event) => this.addModalChangedHandler(event, "addressLastName")}
                                      onLine1Change={(event) => this.addModalChangedHandler(event, "addressLine1")}
                                      onLine2Change={(event) => this.addModalChangedHandler(event, "addressLine2")}
                                      onNewAddressLineClick={(event) => this.addAddressLineModalHandler(event)}
                                      onCityChange={(event) => this.addModalChangedHandler(event, "addressCity")}
                                      stateZoneList={this.state.stateZone}
                                      onStateZoneFocus={(event) => this.stateZoneFocusHandler(event)}
                                      onStateZoneBlur={(event) => this.stateZoneBlurHandler(event)}
                                      onStateZoneChange={(event) => this.addModalChangedHandler(event, "addressStateZone")}
                                      onStateChange={(event) => this.addModalChangedHandler(event, "addressState")}
                                      onPostalChange={(event) => this.addModalChangedHandler(event, "addressPostal")}
                                      onPhoneChange={(event) => this.addModalChangedHandler(event, "addressPhone")}
                                      onSaveClick={this.state.saveAddressActive ? (e) => this.addAddressModalHandler('billing') : null}
                                      onMakeAsDefaultChange={(event) => this.onMakeAsDefaultChange(event)}
                                      isPrimary={item.isPrimary}
                                    />
                                  ) : null}
                                </Address>
                              ))
                            : ""
                          // : ""
                        }
                        {this.state.showAddBilAddressForm ? '' :
                        this.state.confirmAddressSummary && this.state.confirmAddressSummary.length > 1 && this.state.isBillingOptionsOpen ? (
                        <GlobalStyle.AddAddressStyle
                          title="Add an address"
                          className={Cookies.get("kkUserEmail") || this.props.isUserRegistered || this.state.isGuestRegisterSuccess ? "enabled" : "disabled"}
                          onClick={
                            this.props.isUserRegistered || this.state.isGuestRegisterSuccess
                              ? (event) => this.showAddressModalHandler("addBillingAddress")
                              : null
                          }>
                          <p>+ Add Address</p>
                        </GlobalStyle.AddAddressStyle>
                        ) : (
                          ""
                        )}

                        {this.state.showAddBilAddressForm && this.state.isBillingOptionsOpen ? (
                          <AddressForm
                            title="Add address"
                            process="add"
                            close={(event) => this.closeAddressModalHandler(event)}
                            data={this.state}
                            myRef={(input) => {
                              this.addressFirstNameRef = input;
                            }}
                            onCountryFocus={(event) => this.countryFocusHandler(event)}
                            onCountryBlur={(event) => this.countryBlurHandler(event)}
                            onCountryChange={(event) => this.addModalChangedHandler(event, "addressRegion")}
                            countryOptions={this.countryOptionsHandler()}
                            countryComponents={{Option}}
                            onCountryInputChange={this.countryInputHandler}
                            onFirstNameChange={(event) => this.addModalChangedHandler(event, "addressFirstName")}
                            onLastNameChange={(event) => this.addModalChangedHandler(event, "addressLastName")}
                            onLine1Change={(event) => this.addModalChangedHandler(event, "addressLine1")}
                            onLine2Change={(event) => this.addModalChangedHandler(event, "addressLine2")}
                            onNewAddressLineClick={(event) => this.addAddressLineModalHandler(event)}
                            onCityChange={(event) => this.addModalChangedHandler(event, "addressCity")}
                            stateZoneList={this.state.stateZone}
                            onStateZoneFocus={(event) => this.stateZoneFocusHandler(event)}
                            onStateZoneBlur={(event) => this.stateZoneBlurHandler(event)}
                            onStateZoneChange={(event) => this.addModalChangedHandler(event, "addressStateZone")}
                            onStateChange={(event) => this.addModalChangedHandler(event, "addressState")}
                            onPostalChange={(event) => this.addModalChangedHandler(event, "addressPostal")}
                            onPhoneChange={(event) => this.addModalChangedHandler(event, "addressPhone")}
                            onSaveClick={this.state.saveAddressActive ? (e) => this.addAddressModalHandler('billing') : null}
                            onMakeAsDefaultChange={(event) => this.onMakeAsDefaultChange(event)}
                          />
                        ) : null}
                        </div>
                      }
                      </Accordion>

                      {this.state.confirmShippingSummary ? (
                        <Accordion
                          tabName="Delivery"
                          accordionId="accordionShipping"
                          data={this.state}
                          shippingType={this.state.confirmShippingSummary.deliveryMethodLabel}
                          orderSummaryShipping={this.state.shippingFee}
                          shippingPrice={this.state.confirmShippingSummary.pricePerOrder}
                          shippingPerItem={this.state.confirmShippingSummary.pricePerItem}
                          shippingDeliverBy={this.state.confirmShippingSummary.deliveryTime}
                          shippingTotal={this.state.confirmShippingSummary.deliveryCharge}
                          currency={this.state.confirmCurrency}
                          classes="shipping-tab"
                          thisRef={this.accordionPaymentRef}
                          addressChosen={true}
                        />
                      ) : (
                        <Accordion
                          tabName="Delivery"
                          accordionId="accordionShipping"
                          shippingType="0"
                          shippingPrice="0"
                          shippingPerItem="0"
                          shippingDeliverBy="0"
                          shippingTotal="0"
                          currency=""
                          classes="shipping-tab"
                          addressChosen={false}
                          thisRef={this.accordionPaymentRef}
                          data={this.state}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-5 col-lg-4">
                    <div className="section-main-right">
                      <CheckoutSummary
                        data={this.state}
                        bagDiscountCode={this.props.data.discountCode}
                        isNewPromoInput={this.state.promoCodeConfirmInput == this.state.promoCodeConfirm}
                        promoCodeInputFocus={this.promoCodeInputFocusHandler}
                        promoCodeInputBlur={this.promoCodeInputBlurHandler}
                        isPromoCodeInputFocus={this.state.promoCodeInputFocus}
                        promoCodeConfirm={this.state.promoCodeConfirm}
                        promoCodeConfirmInput={this.state.promoCodeConfirmInput}
                        promoCodeMessage={this.state.promoCodeMessage}
                        promoCodeLabel={this.state.promoCodeLabel}
                        promoClassName={this.state.promoClassName}
                        currency={this.state.confirmCurrency || this.props.data.currency}
                        orderDiscountTotal={this.state.orderDiscountTotal}
                        subTotal={
                          this.state.shippingSubTotal
                            ? this.state.confirmCurrency + "" + this.state.shippingSubTotal
                            : this.props.data.orderSummaryTotal
                            ? this.state.confirmCurrency +
                              "" +
                              (this.props.data.discountCode == "ALERTSDISCOUNT"
                                ? (Math.round(parseFloat(this.props.data.orderSummaryTotal.toString().replace(/,/g, "")) * (1 - 0.2) * 100) / 100).toFixed(2)
                                : this.props.data.orderSummaryTotal)
                            : "-"
                        }
                        total={
                          this.state.grandTotal
                            ? this.state.confirmCurrency + "" + this.state.grandTotal
                            : this.props.data.orderSummaryTotal
                            ? this.state.confirmCurrency +
                              "" +
                              (this.props.data.discountCode == "ALERTSDISCOUNT"
                                ? (Math.round(parseFloat(this.props.data.orderSummaryTotal.toString().replace(/,/g, "")) * (1 - 0.2) * 100) / 100).toFixed(2)
                                : this.props.data.orderSummaryTotal)
                            : "-"
                        }
                        vat={
                          this.state.shippingTaxFee
                            ? "Included " + (this.state.taxLabel || "VAT") + " of " + this.state.confirmCurrency + "" + this.state.shippingTaxFee
                            : ""
                        }
                        deliveryLabel={this.state.deliveryLabel}
                        totalLabel={this.state.totalLabel}
                        preorderTotal={this.state.shippingPreOrderTotal}
                        chargeNow={this.state.chargeNow}
                        shippingPrice={this.state.shippingFee ? this.state.confirmCurrency + "" + this.state.shippingFee : ""}
                        updatePromoInput={(event) => this.updatePromoInputHandler(event)}
                        applyPromo={(event) => this.applyPromoHandler(event)}
                        continueToPayment={() => this.continueToPaymentHandler()}
                        isContinuePaymentValid={this.state.isContinuePaymentValid}
                        promoInputValue={this.state.promoInput}
                        type="desktop"
                        className="desktop-checkout-summary"
                        confirmPreorder={this.state.confirmPreorder ? this.state.confirmPreorder.length : 0}
                        confirmAvailable={this.state.confirmAvailable ? this.state.confirmAvailable.length : 0}
                        unavailableCount={this.state.unavailableCount}
                        availableCount={this.state.availableCount}
                        preorderCount={this.state.preorderCount}
                        partialCount={this.state.partialCount}
                        promoCodeInputEntered={this.state.promoCodeInputEntered}
                        addressExists={this.state.confirmAddressSummary}
                        hidePromoFieldBag={this.props.data.hidePromoFieldBag}
                        hidePromoFieldOrderDetails={this.state.hidePromoFieldOrderDetails}
                      />
                    </div>
                  </div>
                </div>
              )}{" "}
            </div>
          </div>
        </GlobalStyle.BodyMainStyle>
        {/* Remove Confirm Cart Item Modal */}
        <Modal
          show={this.state.isRemoveModalOpen}
          close={(event) => this.closeConfirmModalHandler(event)}
        >
          <GlobalStyle.ModalHeadingStyle>
            <p className="modal-title">
              <GlobalStyle.ModalIconStyle className="warning" />
              Remove item?
            </p>
          </GlobalStyle.ModalHeadingStyle>
          <p>Are you sure you want to remove this item from your bag?</p>
          <GlobalStyle.GhostBtnStyle
            onClick={(event) => this.closeConfirmModalHandler(event)}
            ref={this.orderDetailsDeleteModalRef}>
            No, keep item
          </GlobalStyle.GhostBtnStyle>
          <GlobalStyle.MainBtnStyle
            onClick={() => this.deleteItemHandler('order-details')}
          >
            Yes, remove
          </GlobalStyle.MainBtnStyle>
        </Modal>

        {/* Remove Bag Confirm Cart Item Modal */}
        <Modal
          show={this.state.isBagRemoveModalOpen}
          close={(event) => this.closeConfirmModalHandler(event)}
        >
          <GlobalStyle.ModalHeadingStyle>
            <p className="modal-title">
              <GlobalStyle.ModalIconStyle className="warning" />
              Remove item?
            </p>
          </GlobalStyle.ModalHeadingStyle>
          <p>Are you sure you want to remove this item from your bag?</p>
          <GlobalStyle.GhostBtnStyle
            onClick={(event) => this.closeConfirmModalHandler(event)}
            ref={this.bagDeleteModalRef}>
            No, keep item
          </GlobalStyle.GhostBtnStyle>
          <GlobalStyle.MainBtnStyle
            onClick={() => this.deleteItemHandler('bag')}
          >
            Yes, remove
          </GlobalStyle.MainBtnStyle>
        </Modal>
        {/* Delete Address Modal */}
        <Modal show={this.state.isDeleteAddressModalOpen} close={(event) => this.closedeleteAddressModal(event)}>
          <GlobalStyle.ModalHeadingStyle>
            <p className="modal-title">
              <GlobalStyle.ModalIconStyle className="warning" />
              Delete address?
            </p>
          </GlobalStyle.ModalHeadingStyle>
          <p>Are you sure you want to delete this address?</p>
          <GlobalStyle.GhostBtnStyle onClick={(event) => this.closedeleteAddressModal(event)} ref={this.addressDeleteModalRef}>
            No, keep address
          </GlobalStyle.GhostBtnStyle>
          <GlobalStyle.MainBtnStyle onClick={(event) => this.deleteAddressAPI(this.state.addressDeleteId)}>Yes, delete address</GlobalStyle.MainBtnStyle>
        </Modal>
        {/* Change Address Country Modal */}
        <Modal show={this.state.isChangeCountryModalOpen} close={(event) => this.closeChangeCountryModal()}>
          <GlobalStyle.ModalHeadingStyle>
            <p className="modal-title">
              <GlobalStyle.ModalIconStyle className="warning" />
              Change country
            </p>
          </GlobalStyle.ModalHeadingStyle>
          <p>You are about to change your country, but have items in your cart.</p>
          <p>Your current cart items may not be available in the new country you wish to view.</p>
          <p>Do you want to continue?</p>
          <GlobalStyle.GhostBtnStyle onClick={(event) => this.closeChangeCountryModal()} ref={this.changeCountryModalRef}>
            Cancel
          </GlobalStyle.GhostBtnStyle>
          <GlobalStyle.MainBtnStyle onClick={(event) => this.continueChangeCountry(event)}>Continue</GlobalStyle.MainBtnStyle>
        </Modal>
        {/* Add/Edit Address Change Country Modal */}
        <Modal show={this.state.isChangeCountryFormModalOpen} close={(event) => this.closeChangeCountryModal()}>
          <GlobalStyle.ModalHeadingStyle>
            <p className="modal-title">
              <GlobalStyle.ModalIconStyle className="warning" />
              Change country
            </p>
          </GlobalStyle.ModalHeadingStyle>
          <p>You are about to change your country, but have items in your cart.</p>
          <p>Your current cart items may not be available in the new country you wish to view.</p>
          <p>Do you want to continue?</p>
          <GlobalStyle.GhostBtnStyle onClick={(event) => this.closeChangeCountryModal()} ref={this.addEditCountryModalRef}>
            Cancel
          </GlobalStyle.GhostBtnStyle>
          <GlobalStyle.MainBtnStyle onClick={(event) => this.saveAddress()}>Continue</GlobalStyle.MainBtnStyle>
        </Modal>
        {/* Guest Signin / Register Redirect Modal */}
        <Modal show={this.state.isRedirectGuestModalShow} close={(event) => this.closeConfirmModalHandler(event)}>
          <GlobalStyle.ModalHeadingStyle>
            <p className="modal-title">
              <GlobalStyle.ModalIconStyle className="warning" />
              Leave page?
            </p>
          </GlobalStyle.ModalHeadingStyle>
          <p>You are about to leave the current page to sign-in. </p>
          <p>Your bag will be saved, and your saved address will be available. Any changes to address during Guest checkout will not be saved.</p>
          <GlobalStyle.GhostBtnStyle onClick={(event) => this.closeConfirmModalHandler(event)} ref={this.signInModalRef}>
            Cancel
          </GlobalStyle.GhostBtnStyle>
          <a href={this.props.data.signinAndCheckoutLink} onClick={this.signInRedirectHandler} className="link-as-btn">
            Sign in
          </a>
        </Modal>
        <div className="confirm-payment-form">
          <div dangerouslySetInnerHTML={{__html: this.state.confirmPaymentForm}}></div>
        </div>
      </div>
    );
  }
}
export default withRouter(Checkout);
